/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.AppointmentBook.Services {
    export interface AppointmentBookActionsServiceRootScope extends ng.IRootScopeService {
        appointmentBookIncrement: number;
        $broadcast(message: string, ...object: any[]): any;
    }
}

module Meevo.Model {
    export interface AppointmentService {
        entityVersion: number;
    }

    export enum ClipboardActionEnum {
        Cut,
        Copy,
        Rebook,
    }
}

angular.module('ApptBookApp').service('appointmentBookActionsService', [
    'appointmentBookGlobalsService',
    'appointmentBookHelperService',
    'appointmentBookModalService',
    '$rootScope',
    'restServer',
    'Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService',
    '$mdSidenav',
    'meevo.components.common.IdentityService',
    '$mdComponentRegistry',
    '$translate',
    'meevo.components.common.SecurityService',
    '$state',
    '$timeout',
    'meevo.components.tracking.TrackingService',
    'meevo.components.common.DataService',
    'meevo.components.modal.ModalService',
    'meevo.components.common.PrintService',
    '$q',
    '$filter',
    'meevo.plugins.register.RebookService',
    'meevoDateFilterFilter',
    'meevoTimeFilterFilter',
    'meevo.AppSettings',
    'meevo.components.common.RecentService',
    'meevo.plugins.note.NoteService',
    '$mdSidenav',
    'meevo.components.short-cuts.ShortCutsService',
    'meevo.plugins.appointmentBook.stepOverrideService',
    'meevo.plugins.appointmentBook.ProductUsageModalBridge',
    'webComponentRegistry',
(
    globals,
    helper,
    modal: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
    $rootScope: Meevo.Plugins.AppointmentBook.Services.AppointmentBookActionsServiceRootScope,
    restServer,
    filterActions: Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService,
    $mdSidenav: ng.material.ISidenavService,
    identityService: Meevo.Components.Common.IIdentityService,
    $mdComponentRegistry,
    $translate: angular.translate.ITranslateService,
    securityChecker: Meevo.Components.Common.SecurityService,
    $state: any,
    $timeout: ng.ITimeoutService,
    trackingService: Meevo.Components.Tracking.ITrackingService,
    dataService: Meevo.Components.BaseClasses.IDataService,
    modalService: Meevo.Components.Modal.IModalService,
    printService: Meevo.Components.Common.IPrintService,
    $q: ng.IQService,
    $filter: ng.IFilterService,
    rebookService,
    meevoDateFilterFilter,
    meevoTimeFilterFilter,
    appSettings: Meevo.Components.Common.IAppSettings,
    recentService: Meevo.Components.Common.RecentService,
    meevoNoteService: Meevo.Plugins.Note.NoteService,
    sideContextMenu: Meevo.IMeevoSideMenu,
    shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
    stepOverrideService: Meevo.Plugins.AppointmentBook.StepOverride,
    productUsageModalBridge: any,
    webComponentRegistry: { isEnabled(componentId: string): ng.IPromise<boolean> },
) => {
    this.globals = globals;
    this.filterActions = filterActions;

    var _saveUponDelete = false;
    var originalColumnIdAffected = '';
    var isFromWaitList = false;

    var canEditPermission = false;
    var canAddPermission = false;
    let canViewEditPermission = false;
    let canViewAddPermission = false;
    let canDoubleBookResourcePermission = false;
    let canViewDoubleBookResourcePermission = false;
    let appointmentBookSettings: Meevo.Model.AppointmentBookSettings;
    var returnStateInfo = undefined;
    var searchMenuShortCutsGroup: IShortCutGroup;

    function onChangeStateWarning(warnings, onWarningYes) {
        var warningCallback = result => {
            if (result == Meevo.Model.MessageBoxButtonResult.Yes) {
                onWarningYes();
            }
        };

        modal.showMessages(warnings, 'HEADER_APPOINTMENT_WARNING', {
            buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
            callback: warningCallback,
        });
    };

    function getAppointmentScheduleId(details) {
        let defer = $q.defer();

        if (service.details && service.details.id === details.id) {
            defer.resolve(service.details.appointmentScheduleId);
        } else {
            restServer.LoadAppointmentBookDetailPopup(details.id,
                (appointmentService) =>
                {
                    defer.resolve(appointmentService.appointmentScheduleId);
                });
        }

        return defer.promise;
    }

    function getAppointmentBookSettings(): ng.IPromise<Meevo.Model.AppointmentBookSettings> {
        if (appointmentBookSettings) {
            return $q.when(appointmentBookSettings);
        } else {
            //Note: passing undefined for location Id because of bad context again.
            return dataService
                .getSettings<Meevo.Model.AppointmentBookSettings>(
                    Meevo.Model.BusinessSettingCategoryEnum.AppointmentBook,
                    undefined
                )
                .then((response: any) => {
                    appointmentBookSettings = response;
                    return response;
                });
        }
    }

    // SetRemoveCallback (method call) is to enable scrolling right after modal close.. BUG #69325
    modal.setRemoveCallback(removeCallback);
    modalService.setRemoveCallback(removeCallback);

    $rootScope.$on(Meevo.Components.Common.Messages.APPOINTMENT_BOOK_SUGGESTION, ((event, request) => {
        if (request.openingContainer.serviceOpenings != null && request.openingContainer.serviceOpenings.length > 0 && request.openingContainer.serviceOpenings[0].date != null && request.openingContainer.serviceOpenings[0].startTime != null) {
            $timeout(() => {
                filterActions.changeAppointmentBookDateAndTime(request.openingContainer.serviceOpenings[0], false);
            });
        }
    }));

    this.securityChecker = securityChecker;
    if (this.securityChecker == null) {
        this.securityChecker = { hasSecurity: (str: string) => true };
    }

    securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_ADDAPPOINTMENT)
        .then(result => {
            this.canAddPermission = result == Meevo.Model.SecurityAccessEnum.Grant;
            this.canViewAddPermission = result !== Meevo.Model.SecurityAccessEnum.Hide;
        });

    securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_EDITAPPOINTMENT)
        .then(result => {
            this.canEditPermission = result == Meevo.Model.SecurityAccessEnum.Grant;
            this.canViewEditPermission = result !== Meevo.Model.SecurityAccessEnum.Hide;
        });

    securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DOUBLEBOOKRESOURCE)
        .then(result => {
            this.canDoubleBookResourcePermission = result == Meevo.Model.SecurityAccessEnum.Grant;
            this.canViewDoubleBookResourcePermission = result !== Meevo.Model.SecurityAccessEnum.Hide;
        });

    function getStoreDisplay(storeName, storeNumber) {
        return storeName ? (storeName.indexOf(storeNumber) == -1 ? `${storeName} ${storeNumber}` : storeName) : storeNumber;
    }

    // Below method is to enable scrolling right after modal close.. BUG #69325
    function removeCallback() {
        //$(".md-dialog-container").remove();
        $('#divAppointmentBookContainer').focus();
    }

    function deleteAppointDetailsConfirmation() {
        let employeeDeleted = false;
        let resourceDeleted = false;

        var promise = null;
        // different logic when we have integrated register enabled
        if (globals.businessInfo.enableIntegratedRegister) {
            promise = restServer.LoadAppointReasonDetail(service.deleteAppointReason.id);
        }

        if (promise == null) {
            var d = $q.defer();
            d.resolve();
            promise = d.promise;
        }

        promise
            .then(response => {
                let reason = {
                    reasonDetail: null,
                    hasCancellationFee: false,
                };
                if (response && response.data) {
                    reason.reasonDetail = response.data;
                    if (reason.reasonDetail.cancellationAmount > 0) {
                        reason.hasCancellationFee = true;
                    }
                }
                return reason;
            })
            .then(reason => {
                let appointmentServices = {};

                _(service.appointHeaderDelete.services).each((service, i) => {
                    if (service.isApptToDeleteSelected) {
                        let appointmentServiceId = service.id;
                        let appointmentServiceBeingDeleted: any = service;
                        appointmentServices[appointmentServiceId] = appointmentServiceBeingDeleted;
                    }
                });

                // if cancellation has associated fee OR any appointment service has deposits
                // AND user does not have access to the Register, then show error and stop
                const anyHasDeposit = _(appointmentServices).any((appointmentServiceBeingDeleted: any) => appointmentServiceBeingDeleted.depositAmount);
                if (
                    (reason.hasCancellationFee || anyHasDeposit) &&
                    globals.businessInfo.enableIntegratedRegister &&
                    !service.hasRegisterAccess()
                ) {
                    return modal.showMessage($translate.instant('MESSAGE_CANNOT_DELETE_APPT_WITH_FEE_WITH_NO_REGISTER_ACCESS')).then(() => {
                        service.deleteAppointReason = null;
                    });
                }

                for (let appointmentServiceId in appointmentServices) {
                    let appointmentServiceBeingDeleted: any = appointmentServices[appointmentServiceId];

                    if (reason.hasCancellationFee || appointmentServiceBeingDeleted.depositAmount) {
                        globals.apptServicesBeingCancelledWithFee.push({
                            appointmentServiceBeingDeleted: appointmentServiceBeingDeleted,
                            appointmentServiceId: appointmentServiceId,
                            reasonDetail: reason.hasCancellationFee
                                ? reason.reasonDetail
                                : null,
                            depositDetail: appointmentServiceBeingDeleted.depositAmount,
                        });
                    }

                    appointmentServiceBeingDeleted.stateEnum = Meevo.Model.StateEnum.Delete;
                    appointmentServiceBeingDeleted.finalState = Meevo.Model.AppointFinalStateEnum.Cancelled;

                    employeeDeleted = appointmentServiceBeingDeleted.employee ? true : employeeDeleted;
                    resourceDeleted = appointmentServiceBeingDeleted.resource ? true : resourceDeleted;

                    // TODO: investigate using only the startDatetime property on the client-side
                    var appointmentServiceStartDate = moment(appointmentServiceBeingDeleted.startDate);
                    var appointmentServiceStartTime = moment(appointmentServiceBeingDeleted.startTime);

                    appointmentServiceBeingDeleted.startDateTime = appointmentServiceStartDate
                        .startOf('day')
                        .hours(appointmentServiceStartTime.hours())
                        .minutes(appointmentServiceStartTime.minutes())
                        .format();

                    appointmentServiceBeingDeleted.startDate = appointmentServiceStartDate.format();
                    appointmentServiceBeingDeleted.startTime = appointmentServiceStartTime.format();

                    if (isObject(service.deleteAppointReason)) {
                        appointmentServiceBeingDeleted.cancellationReasonId = service.deleteAppointReason.id;
                    }

                    if (!appointmentServiceBeingDeleted.isNew) {
                        if (globals.deletedIds == undefined) globals.deletedIds = [];
                        globals.deletedIds.push(appointmentServiceId);
                    }
                }

                let pendingChanges = _.chain(service.appointHeaderDelete.services)
                    .pluck('id')
                    .difference(globals.deletedIds)
                    .value();

                let isPendingChange = false;

                // if this is coming from the Appointment Editor, originalAppointment will be set
                // if this is coming from the Smart Assistant, originalAppointment is undefined, so skip this block
                if (service.originalAppointment) {
                    for (var i = 0, n = pendingChanges.length; i < n; i++) {
                        var id = pendingChanges[i];

                        let originalService = angular.copy(_(service.originalAppointment.services).findWhere({ id: id }));
                        let appointmentService = angular.copy(_(service.appointHeaderDelete.services).findWhere({ id: id }));

                        if (originalService) {
                            originalService.startTimeSegmented = null;
                            originalService.serviceNoteAlertsCount = null;
                            originalService.serviceNoteAlerts = null;
                        }

                        if (appointmentService) {
                            appointmentService.startTimeSegmented = null;
                            appointmentService.serviceNoteAlertsCount = null;
                            appointmentService.serviceNoteAlerts = null;
                        }

                        if (!angular.equals(originalService, appointmentService)) {
                            isPendingChange = true;
                            break;
                        }
                    }
                }

                if (!isPendingChange || _saveUponDelete) {
                    service.appointHeaderDelete.suppressWarnings = true;

                    // don't include newly added services in delete request
                    let request = angular.copy(service.appointHeaderDelete);
                    request.services = request.services.filter(service => !service.isNew && service.finalState == Meevo.Model.AppointFinalStateEnum.Cancelled);

                    _saveUponDelete = false; // reset

                    if (request.services.length > 0) {
                        restServer.saveAppointHeader(request, onDeleteAppointDetailsSuccess, undefined, true);
                    } else {
                        onDeleteAppointDetailsSuccess(null, null);
                    }

                    modal.hideModal({}).then(() => {
                        let appointmentServiceWithRealClient = _(globals.apptServicesBeingCancelledWithFee)
                            .pluck('appointmentServiceBeingDeleted')
                            .filter(apptService => apptService.clientType === Meevo.Model.ClientTypeEnum.Client);

                        const anyHasCancellationFee = appointmentServiceWithRealClient.length > 0 &&
                            _(globals.apptServicesBeingCancelledWithFee).any(item => item.reasonDetail && item.reasonDetail.cancellationAmount > 0);

                        if (anyHasDeposit || anyHasCancellationFee) {
                            const message = anyHasCancellationFee && anyHasDeposit
                                ? 'MESSAGE_PROCESS_CANCELLATION_FEE_AND_DEPOSIT_REFUND'
                                : anyHasCancellationFee
                                    ? 'MESSAGE_PROCESS_CANCELLATION_FEE'
                                    : 'MESSAGE_PROCESS_DEPOSIT_REFUND';

                            let options: Meevo.Components.Modal.IModalOptions = {
                                templateUrl: 'app/plugins/AppointmentBook/views/CancellationFeeConfirmationModal.html',
                                controller: 'meevo.plugins.appointmentBook.CancellationFeeConfirmationController',
                                controllerAs: 'vm',
                                bindToController: false,
                                locals: {
                                    message: message,
                                },
                            };

                            return modalService.showCustom(options).then(choice => {
                                if (choice !== Meevo.Model.MessageBoxButtonResult.Yes) {
                                    return;
                                }

                                const appointmentService = globals.apptServicesBeingCancelledWithFee[0].appointmentServiceBeingDeleted;

                                restServer.getAppointment(appointmentService.appointmentId).then(response => {
                                    const checkOutServices = [];
                                    const checkOutDetails = [];

                                    _(globals.apptServicesBeingCancelledWithFee).each(item => {
                                        const appointmentService = item.appointmentServiceBeingDeleted;

                                        if (item.reasonDetail && item.reasonDetail.cancellationAmount > 0) {
                                            const cancellationDetail = {
                                                type: Meevo.Model.SalesTypeEnum.ServiceCancellationFee,
                                                appointmentServiceId: appointmentService.id,
                                                cancellationAmount: item.reasonDetail.cancellationAmount,
                                                id: item.reasonDetail.id,
                                                isPercent: item.reasonDetail.isPercent,
                                                applyToAddOns: item.reasonDetail.applyToAddOns,
                                            };

                                            checkOutServices.push(appointmentService);
                                            checkOutDetails.push(cancellationDetail);
                                        }

                                        if (item.depositDetail) {
                                            const depositDetail = {
                                                type: Meevo.Model.SalesTypeEnum.DepositCredit,
                                                appointmentServiceId: appointmentService.id,
                                                depositAmount: -Math.abs(appointmentService.depositAmount),
                                                depositLocationId: appointmentService.depositLocationId,
                                                depositSaleDate: appointmentService.depositSaleDate,
                                                depositSaleId: appointmentService.depositSaleId,
                                                depositSaleLineId: appointmentService.depositSaleLineId,
                                            }

                                            checkOutServices.push(appointmentService);
                                            checkOutDetails.push(depositDetail);
                                        }
                                    });

                                    service.gotoRegisterForCheckOut(
                                        appointmentService,
                                        response.data,
                                        checkOutServices,
                                        checkOutDetails
                                    );
                                });
                            });
                        }
                    }).then(() => {
                        helper.checkReturnToState(service, true);
                    });
                } else {
                    modal.hideModal({}).then(() => {
                        helper.checkReturnToState(service, true);
                    });
                }
            });
    }

    function deletePendingAppointDetailsConfirmation(response) {
        if (response == Meevo.Model.MessageBoxButtonResult.Yes) {
            globals.deletedIds = [];

            let trackItem: Meevo.Model.TrackingItem = new Meevo.Model.TrackingItem(
                Meevo.Model.NounEnum.AppointmentHeader,
                Meevo.Model.VerbEnum.Rejected,
                null,
                service.pendingAppointmentService.appointmentId
            );
            trackingService.saveTrackingInfo(trackItem).catch(reason => {
                /* do nothing */
            });

            restServer.getAppointment(service.pendingAppointmentService.appointmentId).then(function(result) {
                let employeeDeleted = false;
                let resourceDeleted = false;
                result.data.services.forEach(function(appointmentServiceBeingDeleted) {
                    if (appointmentServiceBeingDeleted.appointmentRequestId === service.pendingAppointmentService.appointmentRequestId &&
                        appointmentServiceBeingDeleted.transitionState == Meevo.Model.AppointStateEnum.Pending) {
                        appointmentServiceBeingDeleted.stateEnum = Meevo.Model.StateEnum.Delete;
                        appointmentServiceBeingDeleted.finalState = Meevo.Model.AppointFinalStateEnum.Removed;

                        employeeDeleted = appointmentServiceBeingDeleted.employee ? true : employeeDeleted;
                        resourceDeleted = appointmentServiceBeingDeleted.resource ? true : resourceDeleted;

                        appointmentServiceBeingDeleted.client = {
                            id: appointmentServiceBeingDeleted.clientId,
                        };

                        globals.deletedIds.push(appointmentServiceBeingDeleted.id);
                    }
                });
                if (_saveUponDelete) {
                    result.data.suppressWarnings = true;
                    restServer.saveAppointHeader(
                        result.data,
                        onDeleteAppointDetailsSuccess,
                        null,
                        employeeDeleted,
                        resourceDeleted
                    );
                }
            });
        }
    }

    var refreshAffectedColumn = function(response, affectedColumnId, isSave: boolean = false) {
        let column: any = _.findWhere(globals.columnBookings, { columnId: affectedColumnId });
        if (column && column.isExpanded == undefined) {
            column.isExpanded = false;
        }
        let affectedColumns = [];
        if (!globals.isEmployeeView && response.resourceId) {
            if (column) {
                affectedColumns.push({ date: moment(column.date), entityId: column.resourceId });
            }
            affectedColumns.push({ date: moment(response.startDateTime), entityId: response.resourceId });
        } else if (response.employeeId) {
            if (column) {
                affectedColumns.push({ date: moment(column.date), entityId: column.employeeId });
            }
            if (!column || column.employeeId != response.employeeId) {
                affectedColumns.push({ date: moment(response.startDateTime), entityId: response.employeeId });
            }
        } else if (column) {
            if (globals.isEmployeeView)
                affectedColumns.push({ date: moment(column.date), entityId: column.employeeId });
            else affectedColumns.push({ date: moment(column.date), entityId: column.resourceId });
        }
        var destinationColumnId = null;
        const entityId = globals.isEmployeeView ? response.employeeId : response.resourceUnitId;
        if (entityId) {
            destinationColumnId = helper.GetColumnId(
                moment(response.startDateTime)
                .startOf('day')
                .format(globals.columnDateFormat),
                entityId
            );
            //helper.AdjustColumnCellsForMultiBooking(destinationColumnId);
            helper.AdjustColumns(destinationColumnId, true);
            helper.CalculatePercentageBookedForColumnId(destinationColumnId);
        }

        if (affectedColumnId != undefined && affectedColumnId != destinationColumnId) {
            //helper.AdjustColumnCellsForMultiBooking(affectedColumnId);
            helper.AdjustColumns(affectedColumnId, true);
            helper.CalculatePercentageBookedForColumnId(affectedColumnId);
        }
        if (isSave) {
            $rootScope.$broadcast('appointmentSaved', { affectedColumns: affectedColumns });
        } else {
            $rootScope.$broadcast('appointmentMoved', { affectedColumns: affectedColumns, response });
        }
    };

    var removeAppointDetailsFromBook = function(response, extraData, deletedIds) {
        helper.loadCounts(extraData.resourceChanged, extraData.employeeChanged, filterActions.dates);

        deletedIds.forEach(function(id) {
            var deletedDiv = $(`div[data-id='${id}']`);
            if (deletedDiv.length > 0) {
                var columnId = deletedDiv.parent().attr('id');
                deletedDiv.remove();

                // remove the matching Appointment Service model from the previous column booking
                globals.columnBookings.forEach(function(columnBooking) {
                    columnBooking.appointmentServices = _.without(
                        columnBooking.appointmentServices,
                        _.findWhere(columnBooking.appointmentServices, { id: response.id })
                    );
                    columnBooking.appointmentsAndBlocks = _.without(
                        columnBooking.appointmentsAndBlocks,
                        _.findWhere(columnBooking.appointmentsAndBlocks, { id: response.id })
                    );
                });

                refreshAffectedColumn(response, columnId);
            }
        });

        $rootScope.$broadcast('APPOINTMENT DELETED', null);

        service.closeEditor();
    };

    var onDeleteAppointDetailsSuccess = function (response, extraData) {
        removeAppointDetailsFromBook(response, extraData, globals.deletedIds);
        if (filterActions.isGrouped) {
            filterActions.reGroup();
        }
        globals.deletedIds = [];
    };

    var pendingAppointmentBookedSuccess = function(response, extraData) {
        helper.loadCounts(extraData.resourceChanged, extraData.employeeChanged, filterActions.dates);
        globals.pendingIds.forEach(function (id) {
            var pendingDiv = $(`div[data-id='${id}']`);
            if (pendingDiv.length > 0) {
                pendingDiv.removeClass('pendingAppointment');
                $(pendingDiv).attr('data-ts', Meevo.Model.AppointStateEnum.Booked);
            }
            pendingDiv
                .find(' .call')
                .remove();

            pendingDiv
                .find(' .confirm')
                .show()
                .attr('class', `confirm ${helper.getConfirmClass(response.confirmState)}`);
        });
        if (isFromWaitList)
            $rootScope.$broadcast('appointmentSaved', {
                affectedColumns: null,
                relatedAppointmentRequests: response.relatedAppointmentRequests,
            });
    };

    var onChangeAppointDetailStateSuccess = function (response, updateAppointmentOverlays) {
        $rootScope.$broadcast('DETAIL STATE CHANGED', null);
        helper.setAppointStateIndicator(
            response.id,
            response.transitionState,
            response.finalState,
            response.appointmentEntityVersion,
            updateAppointmentOverlays
        );
        if (response.transitionState === Meevo.Model.AppointStateEnum.NoShow &&
            !filterActions.displayNoShows &&
            filterActions.isGrouped)
        {
            filterActions.reGroup();
        }
        updateColumnBooking(response);
    };

    function showServiceCustomAnswers(): any {
        let modalOptions: Meevo.Components.Modal.IModalOptions = {
            templateUrl: 'app/plugins/AppointmentBook/views/CustomDataSummary.html',
            controller: 'meevo.plugins.appointmentbook.CustomDataSummaryController',
            controllerAs: 'vm',
            bindToController: true,
            locals: {
                context: service,
            },
        };
        return modalService.showCustom(modalOptions);
    }

    function showCustomControls(appointmentServices, forCheckout: boolean, forCheckin: boolean) {
        var defer = $q.defer();
        const appArea = forCheckout ? Meevo.Model.AppAreaEnum.Checkout : Meevo.Model.AppAreaEnum.Checkin;
        let appointmentServicesWithCustomControls = _.filter(appointmentServices, (apptServ: any) => {
            return (
                (forCheckout && apptServ.hasCheckoutCustomControls === forCheckout) ||
                (forCheckin && apptServ.hasCheckinCustomControls === forCheckin)
            );
        });
        if (appointmentServicesWithCustomControls.length > 0) {
            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/AppointmentBook/views/CustomFields.html',
                controller: 'meevo.plugins.appointmentbook.CustomFieldsController',
                controllerAs: 'vm',
                bindToController: true,
                additionalClassName: 'appointment-custom-fields-modal',
                locals: {
                    appointDetails: appointmentServicesWithCustomControls,
                    appArea: appArea,
                    canEdit: true,
                    forceCancel: true,
                },
            };
            modalService.showCustom(modalOptions).then(response => {
                if (response.proceed == 1) {
                    defer.resolve();
                } else {
                    defer.reject();
                }
            });
        } else {
            defer.resolve({ proceed: true });
        }
        return defer.promise;
    }

    function findColumnBooking(id) {
        for (let columnBooking of globals.columnBookings) {
            const entity = _.find(columnBooking.appointmentsAndBlocks, (entry: any) => entry.id === id);
            if (entity) {
                return entity;
            }
        }
        return null;
    }

    function updateColumnBooking(entity) {
        for (let columnBooking of globals.columnBookings) {
            let exit = false;

            let appointmentServicesIndex = _.findIndex(columnBooking.appointmentServices, (entry: any) => entry.id === entity.id);
            if (appointmentServicesIndex !== -1) {
                columnBooking.appointmentServices[appointmentServicesIndex] = entity;
                exit = true;
            }

            let appointmentsAndBlocksIndex = _.findIndex(columnBooking.appointmentsAndBlocks, (entry: any) => entry.id === entity.id);
            if (appointmentsAndBlocksIndex !== -1) {
                columnBooking.appointmentsAndBlocks[appointmentsAndBlocksIndex] = entity;
                exit = true;
            }

            if (exit) {
                return columnBooking;
            }
        }

        return null;
    }

    function saveCustomControls(customControls, saleLineId, appointmentId, appointmentServiceId, appAreaEnum) {
        if (customControls) {
            customControls.answers.forEach(answer => {
                answer.entity_Id = saleLineId;
                answer.auditEntityId = appointmentId;
                answer.auditSubEntityId = appointmentServiceId;
                answer.appAreaEnum = appAreaEnum;
            });
            let data = {
                answers: customControls.answers,
                answerItems: customControls.answerItems,
            };

            return dataService.add(`customData/Answer`, data);
        } else {
            var defer = $q.defer();
            defer.resolve({ proceed: true });
            return defer.promise;
        }
    }

    var onDeleteAppointBlockSuccess = function(response) {
        $rootScope.$broadcast('BLOCK DELETED', null);
        var deletedDivs = $(`div[data-id='${service.block.id}']`);
        for (var index = 0, len = deletedDivs.length; index < len; index++) {
            let deletedDiv = $(deletedDivs[index]);
            var columnId = deletedDiv.parent().attr('id');
            deletedDiv.remove();

            // remove the matching Appointment Service model from the previous column booking
            globals.columnBookings.forEach(function(columnBooking) {
                columnBooking.appointmentsAndBlocks = _.without(
                    columnBooking.appointmentsAndBlocks,
                    _.findWhere(columnBooking.appointmentsAndBlocks, { id: response.id })
                );
            });

            refreshAffectedColumn(response, columnId);
        }
    };

    function clearSelection() {
        var sel;
        var doc: any = document;
        if (doc.selection && doc.selection.empty) {
            doc.selection.empty();
        } else if (window.getSelection) {
            sel = window.getSelection();
            if (sel && sel.removeAllRanges) sel.removeAllRanges();
        }
    }

    function CleanUpCutCopyIds(cutCopyId: string) {
        for (var i = globals.cutCopyIds.length - 1; i >= 0; i--) {
            if (globals.cutCopyIds[i].appointmentServiceId == cutCopyId) {
                globals.cutCopyIds.splice(i, 1);
                break;
            }
        }
    }

    function CutCopy(
        clipboardAction: Meevo.Model.ClipboardActionEnum,
        includeAll: Meevo.Model.MessageBoxButtonResult = Meevo.Model.MessageBoxButtonResult.No,
        confirmIfMultiple: boolean = false,
        appointment: any = null
    ) {
        helper.cleanupPositionHelpers();
        removeExistingClipboardItem(service.details.id);
        helper.destroyResizable();

        var appointmentId = service.details.appointmentId;
        if (confirmIfMultiple) {
            return restServer.getAppointment(appointmentId, true, clipboardAction == Meevo.Model.ClipboardActionEnum.Copy).then(response => {
                var appointment = response.data;
                let clientName: string;
                if (appointment.payingClientType == Meevo.Model.ClientTypeEnum.Client) {
                    clientName = response.data.payingClient.displayName;
                } else {
                    clientName = Meevo.Model.ClientTypeEnum[appointment.payingClientType];
                    clientName.replace('Anonymous', 'Anonymous ');
                }
                if (appointment.services.length > 1) {
                    let cutCopyPrompt = $translate.instant(clipboardAction == Meevo.Model.ClipboardActionEnum.Copy ? "MESSAGE_COPY_MORE_THAN_ONE_SERVICE" : "MESSAGE_CUT_MORE_THAN_ONE_SERVICE", {
                        clientName: clientName
                    });
                    return modal
                        .showMessage(
                            cutCopyPrompt,
                            { buttonsType: Meevo.Model.ButtonTypeEnum.YesNo }
                        )
                        .then(response => {
                            CutCopy(clipboardAction, response.result, false, appointment);
                        });
                } else {
                    CutCopyWorker(clipboardAction, service.details, appointment);
                }
            });
        }

        if (includeAll === Meevo.Model.MessageBoxButtonResult.Yes && appointment != null) {
            appointment.services.forEach(apptService => {
                if (!_.findWhere(globals.cutCopyIds, { appointmentServiceId: apptService.id })) {
                    CutCopyWorker(clipboardAction, apptService, appointment);
                }
            });
        } else {
            return restServer.getAppointment(appointmentId, true).then(response => {
                var appointment = response.data;
                CutCopyWorker(clipboardAction, service.details, appointment);
            });
        }
    }

    function removeExistingClipboardItem(id) {
        let existingClipboardIds: any = _.findWhere(globals.cutCopyIds, { appointmentServiceId: id });
        if (existingClipboardIds) {
            globals.cutCopyIds.splice(globals.cutCopyIds.indexOf(existingClipboardIds), 1);
            let existingClipboardItem = $('#divCutCopy').find(`div[data-id='${existingClipboardIds.id}']`);
            if (existingClipboardItem.length > 0) {
                let clipboardSection = existingClipboardItem.parent().parent();
                existingClipboardItem.parent().remove();
                if (!clipboardSection.find('.cutcopyWrapper').is(':visible')) {
                    clipboardSection.find('.cutCopyHeader').hide();
                }
            }
        }
    }

    function CutCopyWorker(
        clipboardAction: Meevo.Model.ClipboardActionEnum,
        appointmentDetail: any,
        appointment: any
    ) {
        const appointmentServiceId: string = appointmentDetail.id;
        const appointmentId: string = appointment.id;
        const appointmentEntityVersion: any = appointment.entityVersion;
        let container;
        switch (clipboardAction) {
            case Meevo.Model.ClipboardActionEnum.Copy:
                container = $('#divClipboardCopy');
                break;
            case Meevo.Model.ClipboardActionEnum.Cut:
                container = $('#divClipboardCut');
                break;
            case Meevo.Model.ClipboardActionEnum.Rebook:
                container = $('#divClipboardRebook');
                break;
        }
        const padding = 10;
        const headerSpacing = 15;
        const newId = Meevo.Guid.newGuid().toString();

        const original = $(`div[data-id='${appointmentServiceId}']`);
        let clone: JQuery;
        if (original.length > 0) {
            original.data('appointmentEntityVersion', appointmentEntityVersion);
            original.attr('data-appointment-entity-version', appointmentEntityVersion);

            clone = original.clone();
            if (appointmentDetail.finalState === Meevo.Model.AppointFinalStateEnum.CheckedOut) {
                clone.find('.clientName').css('text-decoration', '');
                clone.find('.serviceName').css('text-decoration', '');
                clone.find('.serviceShortcut').css('text-decoration', '');
                clone
                    .find('.confirm')
                    .find('img')
                    .remove();
            }
            clone.data('appointmentId', appointmentId);
            clone.attr('data-appointment-id', appointmentId);
            clone.data('appointmentEntityVersion', appointmentEntityVersion);
            clone.attr('data-appointment-entity-version', appointmentEntityVersion);
            // remove gap booking modifications
            clone
                .find('> .sideBackground')
                .css('margin-left', '0')
                .css('display', '');
            clone
                .find('> .step')
                .css('margin-left', '20px')
                .css('width', 'auto');

            if (clipboardAction == Meevo.Model.ClipboardActionEnum.Cut) {
                helper.addOverlay([appointmentServiceId]);
            } else {
                helper.removeOverlay([appointmentServiceId]);
            }
            // couldn't get data to update but attr works
            clone.attr('data-id', newId);
            clone.find('.appointmentOverlay').remove();
        } else {
            // cannot find appointment service on the book, it could be filtered or not in view for some reason; create it
            clone = helper.buildAppointmentHtmlWithData(appointmentDetail, appointment, null, newId);
        }

        clone.css({ top: 'auto', left: padding / 2, width: globals.columnWidth });
        clone.data('clipboardAction', clipboardAction);
        clone.attr('data-clipboard-action', clipboardAction);

        if (clipboardAction === Meevo.Model.ClipboardActionEnum.Rebook) {
            clone.data('clipboardActionId', newId);
            globals.rebookCandidates[newId] = appointmentDetail;
        } else {
            clone.data('clipboardActionId', appointmentServiceId);
        }

        var fullAppointServiceDetail = findColumnBooking(
            clipboardAction === Meevo.Model.ClipboardActionEnum.Rebook ?
                appointmentDetail.sourceAppointmentServiceId :
                appointmentDetail.id);
        globals.cutCopyIds.push({
            id: newId,
            appointmentServiceId: appointmentServiceId,
            isPasted: false,
            appointServiceDetail: fullAppointServiceDetail
        });

        const height = clone.height() + padding + headerSpacing;
        const width = clone.width() + padding;
        const parentDiv = clone
            .wrap(`<div class="cutcopyWrapper cutcopyAppointment" style="position:relative;margin:10px;height:${height}px;width:${width}px;"></div>`)
            .parent();
        const unassignedEmployee = $translate.instant('LABEL_UNASSIGNED_EMPLOYEE');
        const employeeCode = appointmentDetail.employeeCode ? appointmentDetail.employeeCode : unassignedEmployee;
        parentDiv.prepend(`<div class="clipboardleft">${employeeCode}</div>`);
        let dateTime = "<div class='clipboardright'>" + meevoDateFilterFilter(moment(appointmentDetail.startDateTime).toDate());
        if (clipboardAction !== Meevo.Model.ClipboardActionEnum.Rebook) {
            dateTime += ' ' + meevoTimeFilterFilter(moment(appointmentDetail.startDateTime).toDate());
        }
        dateTime += '</div>';
        parentDiv.prepend(dateTime);

        if (clipboardAction === Meevo.Model.ClipboardActionEnum.Copy) {
            // remove the image associated with a Standing Appointment and Booked Online indicators
            // since they will be removed on the "paste" on the server
            helper.removeIndicatorsForCutCopyClipboard(parentDiv);
        }
        parentDiv.appendTo(container);
        container.find('.cutCopyHeader').show();

        $('.cutcopyAppointment')
            .unbind()
            .click(function() {
                if (globals.isPasting) {
                    return;
                }
                $('.cutcopyWrapper').removeClass('divSelected');
                $(this).addClass('divSelected');
                globals.copyCutAppointmentServiceId = $(this)
                    .find('.appointment')
                    .data('id');
            });

        modal.showCutCopyClipboard();
        if (clipboardAction === Meevo.Model.ClipboardActionEnum.Rebook) {
            service.details = undefined;
        }
        helper.hideSmartAssistant();
    }

    function checkAppointmentHasForms(appointmentService) {
        securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_FORMS).then(result => {
            if (result !== Meevo.Model.SecurityAccessEnum.Grant) {
                return;
            }

            dataService.customMethodData(`api/Appointment/${appointmentService.appointmentId}/AppointmentService/List`, 'get', {}).then(servicesResponse => {
                const request = {
                    AppointmentServicesList: _(servicesResponse.data).pluck('id'),
                };

                dataService.customMethodData('api/DocsAndForms/AppointmentServiceForm/Check', 'post', request).then(formsResponse => {
                    appointmentService.hasDocsAndForms = _(formsResponse.data).any(formsAppointmentService => formsAppointmentService.hasForms);
                });
            });
        });
    }

    globals.showHideCutCopyContainer = function() {
        if ($('#cutCopy_maximized').is(':not(:hidden)')) {
            let cutCopyWidth = $('#divCutCopy').outerWidth();
            $('#standardCellTopRight').css('width', `${cutCopyWidth + globals.timeColumnWidth}px`);
            let scrollContainerWidth = 250 + globals.timeColumnWidth;
            if ($('#timeContainerRight').is(':visible')) {
                scrollContainerWidth += globals.timeColumnWidth;
            }
            $('#divAppointmentBookScrollContainer').css('width', `calc(100% - ${scrollContainerWidth}px)`);
            $('#timeContainerRight').css('right', `${cutCopyWidth}px`);

        }
        else if ($('#divCutCopy').is(':hidden')) {

            let scrollContainerWidth = globals.timeColumnWidth;

            if ($('#timeContainerRight').is(':visible')) {
                $('#timeContainerRight').css('right', 0);
                $('#divAppointmentBookScrollContainer').css('width', `calc(100% - ${scrollContainerWidth * 2}px)`);
            } else {
                $('#divAppointmentBookScrollContainer').css('width', `calc(100% - ${scrollContainerWidth}px)`);
            }

            $('#standardCellTopRight').css('width', `${scrollContainerWidth}px`);

        }

        else {
            let modalWidth = service.GetOpenModalWidth();
            let scrollContainerWidth = modalWidth + globals.timeColumnWidth;


            $('#standardCellTopRight').css('width', `${scrollContainerWidth}px`);

            if ($('#timeContainerRight').is(':visible')) {
                scrollContainerWidth += globals.timeColumnWidth
            }
            $('#divAppointmentBookScrollContainer').css('width', `calc(100% - ${scrollContainerWidth}px)`);
            $('#timeContainerRight').css('right', `${modalWidth}px`);
            $('#divCutCopy').css('right', 0);

        }

        helper.setHeaderCellRootWidth();
    };

    var onAppointmentBookDetailPopupSuccess = function (response, parentColumn) {
        if (response.finalState !== Meevo.Model.AppointFinalStateEnum.None &&
            response.finalState !== Meevo.Model.AppointFinalStateEnum.CheckedOut) {

            // if the response final state is not in either of these states, they must have been changed bc we don't show
            // services in other final states on the book
            service.closeEditor();
            const message = response.finalState === Meevo.Model.AppointFinalStateEnum.Cancelled ?
                $translate.instant('MESSAGE_APPOINTMENT_SERVICE_CANCELLED') :
                $translate.instant('MESSAGE_APPOINTMENT_SERVICE_UPDATED');
            return modal.showMessage(message);
        }

        if (helper.isEditorOpen()) {
            // do not bring up the Smart Assistant when an editor is open
            // it is not sufficient to check at time of click because the click event precedes the double click event
            return;
        }

        checkAppointmentHasForms(response);

        response.isShared = parentColumn.isShared;
        response.storeDisplay = getStoreDisplay(response.storeName, response.storeNumber);
        response.isInPast = parentColumn.isInPast;
        response.isInFuture = parentColumn.isInFuture;
        service.details = response;
        service.block = undefined;
        // update entity version of corresponding appointment service
        $(`div[data-id='${response.id}']`).data('appointmentEntityVersion', response.appointmentEntityVersion);

        globals.displayPCNotes = false;
        globals.displayClNotes = false;
        globals.displayStatus = false;
        globals.divAppointmentDetails.show();

        if (globals.textelPermission || globals.isSmsEnabledCurrentLevel) {
            const payload = {
                clientIds: [service.details.notificationClientId],
                isAnyOptInState: true
            };
            dataService.customMethodData('/api/Client/SmsOptedInState/List', 'POST', payload).then(response => {
                service.details.notificationClientHasMobilePhone = response.data && response.data.length > 0 &&
                    response.data[0] === service.details.notificationClientId;
            });
        }

        if (globals.productUsageTracking) {
            const addOnServiceIds = service.details.serviceAddOns.map(serviceAddOn => serviceAddOn.addOnServiceId);
            const serviceIds = [ service.details.serviceId, ...addOnServiceIds ];

			const request = {
                serviceIds: serviceIds
            };

			dataService.customMethodData(`/api/service/list/productUsageEnabled`, 'POST', request).then(response => {
                service.details.isAnyServiceEnabledForProductUsage = response.data;
            });
        }
    };

    var onAppointmentBookBlockPopupSuccess = function(response, parentColumn) {
        if (helper.isEditorOpen()) {
            // do not bring up the Smart Assistant when an editor is open
            // it is not sufficient to check at time of click because the click event precedes the double click event
            return;
        }
        response.isShared = parentColumn.isShared;
        response.storeDisplay = getStoreDisplay(response.storeName, response.storeNumber);
        response.showSingleDeleteMessage = true;
        response.isInPast = parentColumn.isInPast;
        service.block = response;
        service.details = undefined;
        // update entity version of corresponding block
        $(`div[data-id='${response.id}']`).data('blockEntityVersion', response.entityVersion);

        globals.divBlockDetails.show();
    };

    var onMoveBlockSuccess = function(booking, response, originalColumnId) {
        booking.data('blockEntityVersion', response.entityVersion);

        // remove the matching Appointment Service model from the previous column booking
        globals.columnBookings.forEach(function(columnBooking) {
            columnBooking.appointmentsAndBlocks = _.without(
                columnBooking.appointmentsAndBlocks,
                _.findWhere(columnBooking.appointmentsAndBlocks, { id: response.id })
            );
        });

        UpdateCutCopyBlockEntityVersion(response.id, response.entityVersion);

        // add the response Appointment Service model to the corresponding column booking
        var appointmentDate = moment(response.startDateTime)
            .startOf('day')
            .format(globals.columnDateFormat);
        var columnBookings = null;
        if (globals.isEmployeeView) {
            columnBookings = _.where(globals.columnBookings, {
                employeeId: response.employeeId,
                date: appointmentDate,
            });
        } else {
            columnBookings = _.where(globals.columnBookings, {
                resourceId: response.resourceId,
                date: appointmentDate,
            });
        }
        if (columnBookings && columnBookings.length > 0) {
            columnBookings.forEach(function(columnBooking: any) {
                columnBooking.appointmentsAndBlocks.push(response);
            });
        }

        refreshAffectedColumn(response, originalColumnId);
        helper.expandBook(moment(response.startDateTime), moment(response.endDateTime));

        helper.destroyDraggable();
        helper.destroyResizable();
    };

    var MoveBlockWithWarnings = (blockId, entityVersion, date, time, employeeId, resourceId, onSuccess, copyCutMoveRevert) => {
        var onMoveBlockWarn = warnings => {
            var warningCallback = result => {
                if (result === Meevo.Model.MessageBoxButtonResult.Yes) {
                    restServer.MoveAppointBlock(
                        blockId,
                        entityVersion,
                        date,
                        time,
                        employeeId,
                        resourceId,
                        true /*suppresswarnings*/,
                        onSuccess,
                        undefined,
                        () => copyCutMoveRevert()
                    );
                } else {
                    copyCutMoveRevert();
                }
            };

            modal.showMessages(warnings, 'HEADER_BLOCK_WARNING', {
                buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                callback: warningCallback,
            });
        };

        restServer.MoveAppointBlock(
            blockId,
            entityVersion,
            date,
            time,
            employeeId,
            resourceId,
            false /*don't suppresswarnings*/,
            onSuccess,
            onMoveBlockWarn,
            () => copyCutMoveRevert()
        );
    };

    var onRebookSuccess = (response, extraData) => {
        if (
            !this.globals.isEmployeeView &&
            extraData &&
            extraData.multipleChoiceResponse &&
            extraData.multipleChoiceResponse == 'AutoAssignResources'
        ) {
            this.filterActions.refresh();
            return;
        }

        helper.loadCounts(response.resource, response.employee, filterActions.dates);

        var appointmentDate = moment(response.appointmentDate).startOf('day').format(globals.columnDateFormat);
        let rebookCandidate = globals.rebookCandidates[globals.copyCutMoveBooking.data('clipboardActionId')];
        _.where(globals.columnBookings, { employeeId: rebookCandidate.employeeId, date: appointmentDate }).forEach(
            function(columnBooking: any) {
                refreshAffectedColumn(response, columnBooking.columnId, true);
            }
        );

        CleanUpCutCopyIds(globals.copyCutMoveBooking.data('clipboardActionId'));

        modal.disposeCutCopyClipboardIfEmpty();

        if (!$('#divClipboardRebook').find('.cutcopyWrapper').is(':visible')) {
            if (rebookCandidate.fromRegister) {
                $rootScope.$broadcast('gotoState', { stateName: 'register' });
            }
            $('#divClipboardRebook')
                .find('.cutcopyWrapper')
                .remove();
        }
    };

    var rebookWithWarnings = (appointmentServiceId, date, time, employeeId, resourceUnitId, resourceId, copyCutMoveRevert) => {
        let appointmentService = globals.rebookCandidates[appointmentServiceId];
        appointmentService.employeeId = employeeId;
        appointmentService.steps.forEach(step => {
            step.employeeId = employeeId;
        });
        appointmentService.startDateTime = moment(date + time, 'M-DD-YYYYh:m').format();
        appointmentService.resourceUnitId = resourceUnitId;
        appointmentService.resourceId = resourceId;
        appointmentService.id = undefined;
        let appointment: any = {
            services: [appointmentService],
            payingClientId: appointmentService.clientId,
            payingClientType: Meevo.Model.ClientTypeEnum.Client,
            appointmentDate: date,
            confirmState: Meevo.Model.ConfirmStateEnum.Unconfirmed,
            autoAssignResources: true,
        };

        var onRebookWarnings = warnings => {
            modal.showMessages(warnings, 'HEADER_APPOINTMENT_WARNING', {
                buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                callback: result => {
                    if (result === Meevo.Model.MessageBoxButtonResult.Yes) {
                        appointment.suppressWarnings = true;
                        restServer.saveAppointHeader(
                            appointment,
                            onRebookSuccess,
                            onRebookWarnings,
                            null,
                            null,
                            () => copyCutMoveRevert(appointmentServiceId)
                        );
                    } else {
                        copyCutMoveRevert(appointmentServiceId);
                    }
                },
            });
        };
        restServer.saveAppointHeader(appointment, onRebookSuccess, onRebookWarnings, null, null, () =>
            copyCutMoveRevert(appointmentServiceId)
        );
    };

    var getServiceStepTypeDisplayName = (serviceStepType) => {
        switch (serviceStepType) {
            case Meevo.Model.ServiceStepTypeEnum.Servicing:
                return $translate.instant("LABEL_SERVICING");
            case Meevo.Model.ServiceStepTypeEnum.Gap:
                return $translate.instant("LABEL_GAP");
            case Meevo.Model.ServiceStepTypeEnum.Resource:
                return $translate.instant('LABEL_RESOURCE');
            default:
                return $translate.instant("LABEL_OTHER");
        }
    };

    var checkStepsDuration = (appointmentService) => {
        if (!appointmentService) {
            return;
        }

        const newEmployeeId = appointmentService.employeeId;
        const oldEmployeeId = appointmentService.originalEmployeeId;

        if (newEmployeeId == oldEmployeeId) {
            return;
        }

        const isStepsDurationSame = (originalSteps, templateSteps) => {
            if (originalSteps.length !== templateSteps.length) {
                return false;
            }

            for (let index = 0; index < originalSteps.length; index++)
            {
                const originalStep = originalSteps[index];
                const templateStep = templateSteps[index];

                if (originalStep.durationInMinutes !== templateStep.durationInMinutes ||
                    originalStep.serviceStepType !== templateStep.serviceStepType) {
                    return false;
                }
            }

            return true;
        }

        restServer.getAppointmentServiceTemplateWithAddOns(
            newEmployeeId,
            appointmentService.serviceId,
            appointmentService.clientId,
            null,
            null,
            (templateResponse) => {
                let templateSteps = _(templateResponse.steps).filter(step => step.durationInMinutes !== 0);

                if (isStepsDurationSame(appointmentService.steps, templateSteps)) {
                    return;
                }

                dataService.getItem('employee', newEmployeeId).then((employeeResponse: any) => {
                    const messageHeader = $translate.instant("MESSAGE_STEPS_DURATION_HEADER", {
                        employeeDisplayName: employeeResponse.displayName,
                        serviceShortcut: appointmentService.serviceShortcut,
                        serviceDisplayName: appointmentService.serviceDisplayName,
                        clientDisplayName: $translate.instant(appointmentService.clientDisplayName),
                    });

                    const durationFormat = $filter('durationFormat') as any;
                    const messageList = _(templateResponse.steps)
                        .map(item => `<li>${getServiceStepTypeDisplayName(item.serviceStepType)} ${durationFormat(item.durationInMinutes)}</li>`);

                    const messageFooter = $translate.instant("MESSAGE_STEPS_DURATION_FOOTER");

                    const message = `${messageHeader}<ul style="margin:0.5em 0">${messageList.join('')}</ul>${messageFooter}`;

                    modal.showMessage(message, {
                        showAsHtml: true
                    });
                });
            }
        );
    };

    var MoveWithWarnings = (
        appointmentServiceId,
        appointmentId,
        appointmentEntityVersion,
        date,
        time,
        employeeId,
        resourceUnitId,
        resourceId,
        originalColumnId,
        fromDragAndDrop: boolean = false,
        copyCutMoveRevert
    ) => {
        originalColumnIdAffected = originalColumnId;
        let copyCutMoveBooking = globals.copyCutMoveBooking;
        let onMoveAppointDetailSuccess = (response, extraData)=> {
            checkStepsDuration(response);

            if (
                !this.globals.isEmployeeView &&
                extraData &&
                extraData.multipleChoiceResponse &&
                extraData.multipleChoiceResponse == 'AutoAssignResources'
            ) {
                this.filterActions.refresh();
                return;
            }

            helper.loadCounts(response.resource, response.employee, filterActions.dates);
            service.updateConfirmState(
                response.appointmentId,
                response.appointmentEntityVersion,
                response.appointmentConfirmState
            );
            helper.setAppointStateIndicator(
                response.id,
                response.transitionState,
                response.finalState
            );

            UpdateCutCopyAppointmentEntityVersion(response.appointmentId, response.appointmentEntityVersion);
            delete globals.restrictedIds[copyCutMoveBooking.data('id')];
            globals.isPasting = false;
            copyCutMoveBooking.attr('data-appointment-id', response.appointmentId);
            copyCutMoveBooking.data('appointmentId', response.appointmentId);
            copyCutMoveBooking.attr('data-appointment-entity-version', response.appointmentEntityVersion);
            copyCutMoveBooking.data('appointmentEntityVersion', response.appointmentEntityVersion);
            copyCutMoveBooking.data('clipboardAction', null);
            copyCutMoveBooking.data('clipboardActionId', null);

            // remove the matching Appointment Service model from the previous column booking
            globals.columnBookings.forEach(function (columnBooking) {
                columnBooking.appointmentServices = _.without(
                    columnBooking.appointmentServices,
                    _.findWhere(columnBooking.appointmentServices, { id: response.id })
                );
                columnBooking.appointmentsAndBlocks = _.without(
                    columnBooking.appointmentsAndBlocks,
                    _.findWhere(columnBooking.appointmentsAndBlocks, { id: response.id })
                );
            });

            // add the response Appointment Service model to the corresponding column booking
            var appointmentDate = moment(response.startDateTime).startOf('day').format(globals.columnDateFormat);
            var columnBookings = null;
            if (globals.isEmployeeView) {
                columnBookings = _.where(globals.columnBookings, {
                    employeeId: response.employeeId,
                    date: appointmentDate,
                });
            } else {
                columnBookings = _.where(globals.columnBookings, {
                    resourceId: response.resourceId,
                    date: appointmentDate,
                });
            }
            if (columnBookings && columnBookings.length > 0) {
                columnBookings.forEach(function(columnBooking: any) {
                    columnBooking.appointmentServices.push(response);
                    columnBooking.appointmentsAndBlocks.push(response);
                });
            }

            var cutCopyObj: any = _.findWhere(globals.cutCopyIds, { appointmentServiceId: response.id });
            if (cutCopyObj) {
                cutCopyObj.isPasted = true;
            }

            let newColumnIdAffected = copyCutMoveBooking.parent().attr('id');
            if (
                !extraData ||
                !extraData.fromDragAndDrop ||
                (extraData.fromDragAndDrop && newColumnIdAffected != originalColumnIdAffected)
            ) {
                refreshAffectedColumn(response, newColumnIdAffected, true);
            }
            if (!_.isEmpty(originalColumnIdAffected)) {
                refreshAffectedColumn(response, originalColumnIdAffected);
            }
            helper.expandBook(moment(response.startDateTime), moment(response.startDateTime).add(response.totalMinutes, 'm'));

            originalColumnIdAffected = '';

            helper.destroyDraggable();
            helper.destroyResizable();

            checkForRelatedAppointmentRequest(response);

            modal.disposeCutCopyClipboardIfEmpty();
        };
        var onMoveAppointWarn = warnings => {
            var warningCallback = result => {
                if (result == Meevo.Model.MessageBoxButtonResult.Yes) {
                    CleanUpCutCopyIds(appointmentServiceId);
                    restServer.MoveAppointmentService(
                        appointmentServiceId,
                        appointmentId,
                        appointmentEntityVersion,
                        date,
                        time,
                        employeeId,
                        resourceUnitId,
                        resourceId,
                        this.globals.isEmployeeView,
                        true /*suppresswarnings*/,
                        onMoveAppointDetailSuccess,
                        undefined,
                        () => copyCutMoveRevert(appointmentServiceId),
                        fromDragAndDrop
                    );
                } else {
                    copyCutMoveRevert(appointmentServiceId);
                }
            };

            modal.showMessages(warnings, 'HEADER_APPOINTMENT_WARNING', {
                buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                callback: warningCallback,
            });
        };

        restServer.MoveAppointmentService(
            appointmentServiceId,
            appointmentId,
            appointmentEntityVersion,
            date,
            time,
            employeeId,
            resourceUnitId,
            resourceId,
            this.globals.isEmployeeView,
            false /*don't suppresswarnings*/,
            onMoveAppointDetailSuccess,
            onMoveAppointWarn,
            () => copyCutMoveRevert(appointmentServiceId),
            fromDragAndDrop
        );
    };

    function checkForRelatedAppointmentRequest(response) {
        if (response.relatedAppointmentRequest) {
            let serviceList = '';
            for (let service of response.relatedAppointmentRequest.services) {
                if (service != response.relatedAppointmentRequest.services[0]) {
                    serviceList += ', ';
                }
                serviceList += service.serviceDisplayName;
            }
            modal.showMessage($translate.instant('MESSAGE_DELETE_EXISTING_APPOINTMENT_REQUEST', { serviceList: serviceList }),
                {
                    buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                    callback: result => {
                        if (result === Meevo.Model.MessageBoxButtonResult.Yes) {
                            restServer.deleteAppointmentRequest(
                                response.relatedAppointmentRequest.id,
                                response.relatedAppointmentRequest.entityVersion,
                                false
                            );
                        }
                    },
                }
            );
        }
    }

    var UpdateCutCopyBlockEntityVersion = (newBlockId, newBlockEntityVersion) => {
        let container = $('#divCutCopyDetails');
        let pastedBlockId = globals.copyCutMoveBooking.data('id');
        let oldBlockId = globals.copyCutMoveBooking.data('id');
        let oldBlockInPasteBoard = $(container)
            .find('div.cutcopyWrapper')
            .not('.hideHighlight')
            .find(`div[data-block-id="${oldBlockId}"]`);

        if (oldBlockInPasteBoard.length > 0) {
            let oldBlockCallback = (data, extraData) => {
                // check if there are additional blocks on the paste board with the original block id
                oldBlockInPasteBoard.each((ndx, bookingInPasteBoard) => {
                    $(bookingInPasteBoard).attr('data-block-entity-version', data.entityVersion);
                    $(bookingInPasteBoard).data('blockEntityVersion', data.entityVersion);

                    let cutCopyId = $(bookingInPasteBoard).data('clipboardActionId');
                    if (cutCopyId && cutCopyId != pastedBlockId) {
                        let cutCopyBooking = $(`div[data-block-id="${cutCopyId}"]`);
                        if (cutCopyBooking.length > 0) {
                            cutCopyBooking.attr('data-block-entity-version', data.entityVersion);
                            cutCopyBooking.data('blockEntityVersion', data.entityVersion);
                        }
                    }
                });
            };

            let otherBlockId = $(oldBlockInPasteBoard[0]).data('clipboardActionId');
            if (otherBlockId) {
                restServer.LoadAppointmentBookBlockPopup(otherBlockId, oldBlockCallback, null);
            }
        }

        // check if there are additional blocks on the paste board with the response appointment id
        let newBlockInPasteBoard = $(container).find(`div[data-id="${newBlockId}"]`);
        if (newBlockInPasteBoard.length > 0) {
            newBlockInPasteBoard.each((ndx, bookingInPasteBoard) => {
                $(bookingInPasteBoard).attr('data-block-entity-version', newBlockEntityVersion);
                $(bookingInPasteBoard).data('blockEntityVersion', newBlockEntityVersion);

                let cutCopyId = $(bookingInPasteBoard).data('clipboardActionId');
                if (cutCopyId) {
                    let cutCopyBooking = $(`div[data-id="${cutCopyId}"]`);
                    if (cutCopyBooking.length > 0) {
                        cutCopyBooking.attr('data-block-entity-version', newBlockEntityVersion);
                        cutCopyBooking.data('blockEntityVersion', newBlockEntityVersion);
                    }
                }
            });
        }
    };

    var UpdateCutCopyAppointmentEntityVersion = (newAppointmentId, newAppointmentEntityVersion) => {
        let container = $('#divCutCopyDetails');
        let pastedAppointmentServiceId = globals.copyCutMoveBooking.data('id');
        let oldAppointmentId = globals.copyCutMoveBooking.data('appointmentId');
        let oldApptSvcInPasteBoard = $(container)
            .find('div.cutcopyWrapper')
            .not('.hideHighlight')
            .find(`div[data-appointment-id="${oldAppointmentId}"]`);

        if (oldApptSvcInPasteBoard.length > 0) {
            let oldApptSvcCallback = (data, extraData) => {
                // check if there are additional appointment services on the paste board with the original appointment id
                oldApptSvcInPasteBoard.each((ndx, bookingInPasteBoard) => {
                    $(bookingInPasteBoard).attr('data-appointment-entity-version', data.appointmentEntityVersion);
                    $(bookingInPasteBoard).data('appointmentEntityVersion', data.appointmentEntityVersion);

                    let cutCopyId = $(bookingInPasteBoard).data('clipboardActionId');
                    if (cutCopyId && cutCopyId != pastedAppointmentServiceId) {
                        let cutCopyBooking = $(`div[data-id="${cutCopyId}"]`);
                        if (cutCopyBooking.length > 0) {
                            cutCopyBooking.attr('data-appointment-entity-version', data.appointmentEntityVersion);
                            cutCopyBooking.data('appointmentEntityVersion', data.appointmentEntityVersion);
                        }
                    }
                });
            };

            let otherAppointmentServiceId = $(oldApptSvcInPasteBoard[0]).data('clipboardActionId');
            if (otherAppointmentServiceId) {
                restServer.LoadAppointmentBookDetailPopup(otherAppointmentServiceId, oldApptSvcCallback, null);
            }
        }

        // check if there are additional appointment services on the paste board with the response appointment id
        let newApptSvcInPasteBoard = $(container).find(`div[data-appointment-id="${newAppointmentId}"]`);
        if (newApptSvcInPasteBoard.length > 0) {
            newApptSvcInPasteBoard.each((ndx, bookingInPasteBoard) => {
                $(bookingInPasteBoard).attr('data-appointment-entity-version', newAppointmentEntityVersion);
                $(bookingInPasteBoard).data('appointmentEntityVersion', newAppointmentEntityVersion);

                let cutCopyId = $(bookingInPasteBoard).data('clipboardActionId');
                if (cutCopyId) {
                    let cutCopyBooking = $(`div[data-id="${cutCopyId}"]`);
                    if (cutCopyBooking.length > 0) {
                        cutCopyBooking.attr('data-appointment-entity-version', newAppointmentEntityVersion);
                        cutCopyBooking.data('appointmentEntityVersion', newAppointmentEntityVersion);
                    }
                }
            });
        }
    };

    var CopyWithWarnings = (
        appointmentServiceId,
        appointmentId,
        appointmentEntityVersion,
        date,
        time,
        employeeId,
        resourceUnitId,
        resourceId,
        copyCutMoveRevert
    ) => {
        globals.isPasting = true;
        let copyCutMoveBooking = globals.copyCutMoveBooking;
        let onCopyAppointDetailSuccess = (response, extraData)=> {
            checkStepsDuration(response);

            if (!this.globals.isEmployeeView &&
                extraData &&
                extraData.multipleChoiceResponse &&
                extraData.multipleChoiceResponse == 'AutoAssignResources'
            ) {
                this.filterActions.refresh();
                return;
            }

            helper.loadCounts(response.resource, response.employee, filterActions.dates);
            var originalAppointmentServiceId = extraData.appointmentServiceId;

            copyCustomControls(response, originalAppointmentServiceId);
            UpdateCutCopyAppointmentEntityVersion(response.appointmentId, response.appointmentEntityVersion);

            delete globals.restrictedIds[copyCutMoveBooking.data('id')];
            copyCutMoveBooking.data('id', response.id);
            copyCutMoveBooking.attr('data-id', response.id);
            copyCutMoveBooking.data('appointmentId', response.appointmentId);
            copyCutMoveBooking.attr('data-appointment-id', response.appointmentId);
            copyCutMoveBooking.data('appointmentEntityVersion', response.appointmentEntityVersion);
            copyCutMoveBooking.attr('data-appointment-entity-version', response.appointmentEntityVersion);
            copyCutMoveBooking.data('clipboardAction', null);
            copyCutMoveBooking.data('clipboardActionId', null);
            globals.isPasting = false;

            //manipulate Resource changed on target
            let copyAppointmentTargetResourceNameElement = $(`div[data-id='${response.id}']`).find('.empResName');
            if (copyAppointmentTargetResourceNameElement && copyAppointmentTargetResourceNameElement.length > 0) {
                let unassignedEmployee = $translate.instant('LABEL_UNASSIGNED_EMPLOYEE');
                let employeeCode = response.employeeCode
                    ? response.employeeCode
                    : `[${unassignedEmployee}]`;
                copyAppointmentTargetResourceNameElement[0].innerHTML = (globals.isEmployeeView ? `${response.resourceShortcut}<br>` : `${response.employeeCode}<br>`);
            }

            var copyAppointmentSource = $(`div[data-id='${globals.copyCutAppointmentServiceId}']`);
            // Only update version if appointment ids match b/c if copying to another day, this will affect a different appointment
            if (copyAppointmentSource.data('appointmentId') == response.appointmentId) {
                copyAppointmentSource.data('appointmentEntityVersion', response.appointmentEntityVersion);
                copyAppointmentSource.attr('data-appointment-entity-version', response.appointmentEntityVersion);
            }

            // add the response Appointment Service model to the corresponding column booking
            var appointmentDate = moment(response.startDateTime).startOf('day').format(globals.columnDateFormat);
            var columnBookings = null;
            if (globals.isEmployeeView) {
                columnBookings = _.where(globals.columnBookings, {
                    employeeId: response.employeeId,
                    date: appointmentDate,
                });
            } else {
                columnBookings = _.where(globals.columnBookings, {
                    resourceId: response.resourceId,
                    date: appointmentDate,
                });
            }
            if (columnBookings && columnBookings.length > 0) {
                columnBookings.forEach(function(columnBooking: any) {
                    columnBooking.appointmentServices.push(response);
                    columnBooking.appointmentsAndBlocks.push(response);
                    refreshAffectedColumn(response, columnBooking.columnId);
                });
            }

            helper.expandBook(moment(response.startDateTime), moment(response.startDateTime).add(response.totalMinutes, 'm'));
            checkForRelatedAppointmentRequest(response);
            service.updateConfirmState(
                response.appointmentId,
                response.appointmentEntityVersion,
                response.appointmentConfirmState
            );

            modal.disposeCutCopyClipboardIfEmpty();
            helper.updateStepsOnCopyPaste(response);
        };

        var onCopyAppointWarn = warnings => {
            var warningCallback = result => {
                if (result == Meevo.Model.MessageBoxButtonResult.Yes) {
                    restServer.CopyAppointmentService(
                        appointmentServiceId,
                        appointmentId,
                        appointmentEntityVersion,
                        date,
                        time,
                        employeeId,
                        resourceUnitId,
                        resourceId,
                        this.globals.isEmployeeView,
                        true /*suppresswarnings*/,
                        onCopyAppointDetailSuccess,
                        undefined,
                        () => copyCutMoveRevert()
                    );
                } else {
                    copyCutMoveRevert();
                }
            };

            modal.showMessages(warnings, 'HEADER_APPOINTMENT_WARNING', {
                buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                callback: warningCallback,
            });
        };

        restServer.CopyAppointmentService(
            appointmentServiceId,
            appointmentId,
            appointmentEntityVersion,
            date,
            time,
            employeeId,
            resourceUnitId,
            resourceId,
            this.globals.isEmployeeView,
            false /*dont suppresswarnings*/,
            onCopyAppointDetailSuccess,
            onCopyAppointWarn,
            () => copyCutMoveRevert()
        );
    };

    var CopyAppointBlockWithWarnings = (
        blockId,
        blockEntityVersion,
        date,
        time,
        employeeId,
        resourceUnitId,
        resourceId,
        copyCutMoveRevert
    ) => {
        globals.isPasting = true;
        let copyCutMoveBooking = globals.copyCutMoveBooking;
        let onCopyBlockSuccess = (response, extraData) => {
            helper.loadCounts(response.resource, response.employee, filterActions.dates);

            UpdateCutCopyBlockEntityVersion(response.id, response.entityVersion);

            delete globals.restrictedIds[copyCutMoveBooking.data('id')];
            copyCutMoveBooking.data('id', response.id);
            copyCutMoveBooking.attr('data-id', response.id);
            copyCutMoveBooking.data('blockEntityVersion', response.entityVersion);
            copyCutMoveBooking.attr('data-block-entity-version', response.entityVersion);
            copyCutMoveBooking.data('clipboardAction', null);
            copyCutMoveBooking.data('clipboardActionId', null);
            globals.isPasting = false;

            // add the response Appointment Service model to the corresponding column booking
            var blockDate = moment(response.startDateTime).startOf('day').format(globals.columnDateFormat);
            var columnBookings = null;
            if (globals.isEmployeeView) {
                columnBookings = _.where(globals.columnBookings, { employeeId: response.employeeId, date: blockDate });
            } else {
                columnBookings = _.where(globals.columnBookings, { resourceId: response.resourceId, date: blockDate });
            }
            if (columnBookings && columnBookings.length > 0) {
                columnBookings.forEach(function(columnBooking: any) {
                    columnBooking.appointmentsAndBlocks.push(response);

                    refreshAffectedColumn(response, columnBooking.columnId);
                });
            }
            helper.expandBook(moment(response.startDateTime), moment(response.endDateTime));
        }

        var onCopyBlockWarn = warnings => {
            var warningCallback = result => {
                if (result == Meevo.Model.MessageBoxButtonResult.Yes) {
                    restServer.CopyAppointBlock(
                        blockId,
                        blockEntityVersion,
                        date,
                        time,
                        employeeId,
                        resourceUnitId,
                        resourceId,
                        true /*suppresswarnings*/,
                        onCopyBlockSuccess,
                        undefined,
                        () => copyCutMoveRevert()
                    );
                } else {
                    copyCutMoveRevert();
                }
            };

            modal.showMessages(warnings, 'HEADER_APPOINTMENT_WARNING', {
                buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                callback: warningCallback,
            });
        };

        restServer.CopyAppointBlock(
            blockId,
            blockEntityVersion,
            date,
            time,
            employeeId,
            resourceUnitId,
            resourceId,
            false /*dont suppresswarnings*/,
            onCopyBlockSuccess,
            onCopyBlockWarn,
            () => copyCutMoveRevert()
        );
    };

    function copyCustomControls(appointmentService, originalAppointmentServiceId) {
        dataService
            .add(`CustomData/ApptServiceAnswer/List`, {
                Criteria: {
                    apptServiceList: [
                        {
                            serviceId: appointmentService.serviceId,
                            entityId: originalAppointmentServiceId,
                        },
                    ],
                    appAreaEnum: Meevo.Model.AppAreaEnum.Booking,
                },
            })
            .then(data => {
                var customControls = _.pluck(data, 'control');
                if (customControls.length > 0) {
                    let answers = [];
                    customControls.forEach(customControl => {
                        customControl.answers.forEach(answer => {
                            answers.push({
                                entity_Id: appointmentService.id,
                                appAreaEnum: Meevo.Model.AppAreaEnum.Booking,
                                control_TId: answer.control_TId,
                                displayValue: answer.displayValue,
                                auditEntityId: appointmentService.appointmentId,
                                answerItems: [],
                            });
                        });
                    });

                    let data = {
                        answers: answers
                    };
                    dataService.add(`customData/Answer`, data);
                }
            });
    }

    function CopyAppointDetail(appointDetail, clipboardAction: Meevo.Model.ClipboardActionEnum) {
        var clone = appointDetail.clone();
        var guid = Meevo.Guid.newGuid().toString();
        appointDetail.data('copyReplaceId', guid);
        // needed to update the attribute using .attr() since .data() does not do that
        clone.data('id', guid);
        clone.attr('data-id', guid);
        clone.data('clipboardActionId', appointDetail.data('clipboardActionId'));
        clone.attr('data-clipboard-action-id', appointDetail.data('clipboardActionId'));
        clone.data('clipboardAction', appointDetail.data('clipboardAction'));
        clone.attr('data-clipboard-action', appointDetail.data('clipboardAction'));
        if (clipboardAction === Meevo.Model.ClipboardActionEnum.Copy) {
            clone.data('appointmentId', appointDetail.data('appointmentId'));
            clone.attr('data-appointment-id', appointDetail.data('appointmentId'));
            clone.data('appointmentEntityVersion', appointDetail.data('appointmentEntityVersion'));
            clone.attr('data-appointment-entity-version', appointDetail.data('appointmentEntityVersion'));
        } else if (clipboardAction === Meevo.Model.ClipboardActionEnum.Rebook) {
            var appointServiceId =  _(globals.cutCopyIds).findWhere({ id: appointDetail.data('id') })
                .appointmentServiceId;
            var appointServiceDetail = findColumnBooking(appointServiceId);
            globals.cutCopyIds.push({
                id: guid,
                appointmentServiceId: _(globals.cutCopyIds).findWhere({ id: appointDetail.data('id') })
                    .appointmentServiceId,
                isPasted: false,
                appointServiceDetail
            });
        }
        clone.appendTo(appointDetail.parent());

        return guid;
    }

    function CopyCutMove(booking, cell, originalPosition, fromDragAndDrop: boolean = false) {
        let clipboardAction = booking.data('clipboardAction');
        var originalColumnId = booking.parent().attr('id');

        if (clipboardAction === Meevo.Model.ClipboardActionEnum.Cut ||
            clipboardAction === Meevo.Model.ClipboardActionEnum.Rebook
        ) {
            // Move booking back to original spot in the case of a drag/drop from clipboard
            booking.css('top', originalPosition.top).css('left', originalPosition.left);

            // hide highlight div.  need to hide and not just remove in case change is reverted
            booking
                .parent()
                .removeClass('divSelected')
                .addClass('hideHighlight')
                .hide();
            if (!booking
                    .parent()
                    .parent()
                    .find('.cutcopyWrapper')
                    .is(':visible')
            ) {
                booking
                    .parent()
                    .parent()
                    .find('.cutCopyHeader')
                    .hide();
            }

            if (clipboardAction === Meevo.Model.ClipboardActionEnum.Cut) {
                // Switch booking to original appointmetn and act on that
                var originalBooking = $(`div[data-id='${booking.data('clipboardActionId')}']`);
                if (originalBooking.length > 0) {
                    booking = originalBooking;
                    originalColumnId = booking.parent().attr('id');
                    // Need this in case of revert
                    originalPosition.top = booking.position().top;
                } else {
                    // This is the case where they've changed days and the original appointment is no longer on the screen.  Need to create a new instance of the div
                    let clonedBooking = booking.clone();
                    clonedBooking.data('id', booking.data('clipboardActionId'));
                    // Need to update the attribute value as well
                    clonedBooking.attr('data-id', booking.data('clipboardActionId'));
                    // When cloning, latest values of data attribs won't be copied so need to do it manually
                    clonedBooking.data('appointmentEntityVersion', $(booking).data('appointmentEntityVersion'));
                    clonedBooking.attr(
                        'data-appointment-entity-version',
                        $(booking).data('appointmentEntityVersion')
                    );
                    clonedBooking.data('appointmentId', $(booking).data('appointmentId'));
                    clonedBooking.attr('data-appointment-id', $(booking).data('appointmentId'));
                    booking = clonedBooking;
                    originalColumnId = undefined; // This doens't matter as since the original column is no longer on the screen, nothing nees to be reverted back
                    originalPosition.top = 0;
                }
            }
            modal.hideClipIfNoVisibleChildren();

            helper.removeOverlay([booking.data('clipboardActionId')]);
        }
        booking.css('top', cell.top).css('left', 'auto');

        var destinationColumnId = cell.columnId;
        booking.detach().appendTo('#' + destinationColumnId);
        let bookingDataId = booking.data('id');
        let copyCutMoveRevert = function (appointmentServiceId: string = null) {
            globals.isPasting = false;

            delete globals.restrictedIds[bookingDataId];
            service.copyCutMoveRevertCallback(
                booking,
                originalPosition.top,
                originalColumnId,
                destinationColumnId,
                clipboardAction
            );

            if (appointmentServiceId) {
                let clipboardAppointmentIds: any;
                if (clipboardAction == Meevo.Model.ClipboardActionEnum.Cut) {
                    clipboardAppointmentIds = _.findWhere(globals.cutCopyIds, {
                        appointmentServiceId: appointmentServiceId,
                    });
                } else if (clipboardAction == Meevo.Model.ClipboardActionEnum.Rebook) {
                    let rebookAppointmentIds: any = _.findWhere(globals.cutCopyIds, { id: appointmentServiceId });
                    clipboardAppointmentIds = _(globals.cutCopyIds).find(idPair => {
                        return (
                            idPair.id != appointmentServiceId &&
                                idPair.appointmentServiceId == rebookAppointmentIds.appointmentServiceId
                        );
                    });
                    $("#divClipboardRebook").find(`[data-clipboard-action-id='${rebookAppointmentIds.id}']`).data("clipboard-action-id", clipboardAppointmentIds.id);
                    globals.cutCopyIds.splice(globals.cutCopyIds.indexOf(rebookAppointmentIds), 1);
                    globals.rebookCandidates[clipboardAppointmentIds.id] =
                        globals.rebookCandidates[rebookAppointmentIds.id];
                    delete globals.rebookCandidates[appointmentServiceId];
                }
                if (clipboardAppointmentIds) {
                    var cutCopyItem = $(`div[data-id="${clipboardAppointmentIds.id}"]`);
                    if (cutCopyItem) {
                        cutCopyItem.css('top', '3px');
                        cutCopyItem
                            .parent()
                            .removeClass('hideHighlight')
                            .show();
                        cutCopyItem
                            .parent()
                            .parent()
                            .find('.cutCopyHeader')
                            .show();
                        modal.showCutCopyClipboard();
                        helper.addOverlay([clipboardAppointmentIds.appointmentServiceId]);
                    }
                } else {
                    filterActions.filterBook(true, true);
                }
            } else {
                filterActions.filterBook(true, true);
            }
        };
        service.CopyCutMoveFinal(booking, cell, originalColumnId, fromDragAndDrop, copyCutMoveRevert);
    }

    function changeAppointmentServiceState(newAppointState) {
        helper.cleanupPositionHelpers();
        helper.hideSmartAssistant();
        let defer = $q.defer();
        let onWarningYes = () => {
            restServer
                .changeAppointmentServiceState(
                    service.details.id,
                    service.details.appointmentId,
                    service.details.appointmentEntityVersion,
                    newAppointState,
                    service.details.startDateTime,
                    (response, updateAppointmentOverlays) => {
                        onChangeAppointDetailStateSuccess(response, updateAppointmentOverlays);
                        service.details.transitionState = newAppointState;
                    },
                    undefined,
                    true
                ).then(() => {
                    defer.resolve();
                });
        }

        let onChangeStateWarningLocal = (warnings) => {
            onChangeStateWarning(warnings, onWarningYes)
        }

         restServer
            .changeAppointmentServiceState(
                service.details.id,
                service.details.appointmentId,
                service.details.appointmentEntityVersion,
                newAppointState,
                service.details.startDateTime,
                (response, updateAppointmentOverlays) => {
                    onChangeAppointDetailStateSuccess(response, updateAppointmentOverlays);
                    service.details.transitionState = newAppointState;
                },
                onChangeStateWarningLocal,
                false
        ).then((response) => {
            if (!response.data.isWarning) {
                defer.resolve()
            }
        })
        return defer.promise;

    }

    function showDocsAndFormsWorker(
        appointmentServices,
        formCollectionState: Meevo.Plugins.AppointmentBook.FormCollectionStateEnum = Meevo.Plugins.AppointmentBook.FormCollectionStateEnum.Checkin,
        includePromptForms: boolean = false,
        forceDisplay: boolean = false
    ) {
        let defer = $q.defer();

        securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_FORMS)
            .then((result) => {
                if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                    let clientAppointmentServices = _(appointmentServices).where({
                        clientType: Meevo.Model.ClientTypeEnum.Client,
                    });
                    if (clientAppointmentServices.length > 0 || forceDisplay) {
                        let request: any = {
                            AppointmentServicesList: _(clientAppointmentServices).pluck('id'),
                            TriggerEventEnum: Meevo.Model.DocsAndFormsTriggerEventEnum.Booked,
                            isBuilt: true,
                        };
                        if (!includePromptForms) {
                            request.isRequired = true;
                        }
                        dataService
                            .customMethodData('api/DocsAndForms/AppointmentServiceForm/List', 'post', request)
                            .then((formsResponse) => {
                                let formsToDisplay = forceDisplay
                                    ? formsResponse.data
                                    : _(formsResponse.data).filter((form) => !form.isSubmitted);
                                if (formsToDisplay.length > 0 || forceDisplay) {
                                    modal.showDocsAndForms(formsToDisplay, formCollectionState, request, appointmentServices, () => defer.resolve()).then(() => defer.resolve());
                                } else {
                                    defer.resolve();
                                }
                            });
                    } else {
                        defer.resolve();
                    }
                } else {
                    defer.resolve();
                }
            });

        return defer.promise;
    }

    function addRecentClient(appointmentService) {
        recentService.addRecent(
            {
                id: appointmentService.clientId,
                lastName: appointmentService.clientLastName,
                firstName: appointmentService.clientFirstName,
                displayName: appointmentService.clientDisplayName,
            },
            Meevo.Components.Common.Constants.RECENT_KEY_CLIENT,
            true
        );
    }

    function setHighlightedCellTime(cell) {
        globals.divCellHighlight.text(meevoTimeFilterFilter(moment(cell.date + ' ' + cell.time, 'MM-DD-YYYY hh:mm').toDate()));
    }

    //AB and Client Notes
    function getAggregatedNotes(
        noteClient: Meevo.Plugins.Note.INoteClient,
        noteServices: Meevo.Plugins.Note.INoteService[],
        noteViewTime: Meevo.Model.ClientNoteViewTimeEnum,
        isCheckingOut: boolean,
        showClientNote: boolean
    ): ng.IPromise<Meevo.Plugins.Note.INote[]> {
        //console.log('AppointmentBookActionsServices:getAggregatedNotes', arguments);

        if (!noteClient || !showClientNote) {
            return $q.resolve([]);
        }

        const isRegisterNoteValid = (note: Meevo.Plugins.Note.INote, noteViewTime: Meevo.Model.ClientNoteViewTimeEnum, isCheckingOut: boolean): boolean => {
            if (!note || !note.noteText) {
                return false;
            }

            //if Client Note is configured as Check In and Register, we do not display it on CheckOut since it will be handled by Register module
            //if Register Module is off, Client "Check In" or "Check-In/Register" message still needs to be displayed. Note: "Register" note only is not handled whether Register Module is On or Off

            if (noteViewTime === Meevo.Model.ClientNoteViewTimeEnum.CheckIn &&
                note.isCheckOut === true &&
                isCheckingOut &&
                globals.businessInfo.enableIntegratedRegister) {
                return false;
            }

            return true;
        }

        const isMembershipNoteValid = (note: Meevo.Plugins.Note.INote, noteViewTime: Meevo.Model.ClientNoteViewTimeEnum): boolean => {
            if (!note || !note.noteText) {
                return false;
            }

            if (noteViewTime !== Meevo.Model.ClientNoteViewTimeEnum.AppointmentBooked) {
                return false;
            }

            return true;
        }

        const isNoteValid = (note: Meevo.Plugins.Note.INote): boolean => {
            const isValidAppointmentNote = note.isAppointmentNote;
            const isValidClientNote = note.isClientNote && isRegisterNoteValid(note, noteViewTime, isCheckingOut);
            const isValidMembershipNote = note.isMembershipNote && isMembershipNoteValid(note, noteViewTime);
            const isValidServiceNote = note.isServiceNote && isRegisterNoteValid(note, noteViewTime, isCheckingOut);

            const isValidNote =
                isValidAppointmentNote ||
                isValidClientNote ||
                isValidMembershipNote ||
                isValidServiceNote;

            return isValidNote;
        }

        const noteClients = [ noteClient ];

        return meevoNoteService.loadAggregatedNotes(null, noteClients, noteServices, noteViewTime).then((response) => {
            const aggregatedNotes: Meevo.Plugins.Note.INote[] = [];

            for (const noteClient of noteClients) {
                const parsedNotes = meevoNoteService.parseAggregatedNotes(response.data, noteClient);
                aggregatedNotes.push(...parsedNotes);
            }

            for (const noteService of noteServices) {
                const parsedNotes = _(meevoNoteService.parseAggregatedNotes(response.data, noteService)).sortBy("isTenantOrOwnedServiceNote");
                aggregatedNotes.push(...parsedNotes);
            }

            const validAggregatedNotes: Meevo.Plugins.Note.INote[] = [];

            for (const aggregatedNote of aggregatedNotes) {
                if (isNoteValid(aggregatedNote)) {
                    validAggregatedNotes.push(aggregatedNote);
                }
            }

            return validAggregatedNotes;
        });
    }

    function displayCombinedNote(
        appointmentNoteList: any[],
        noteClient: Meevo.Plugins.Note.INoteClient,
        noteServices: Meevo.Plugins.Note.INoteService[],
        aggregatedNotes: Meevo.Plugins.Note.INote[],
        isCheckingOut: boolean,
        anyNotCheckedInServicesForCheckOut: boolean,
        noteViewTime: Meevo.Model.ClientNoteViewTimeEnum
    ) {
        //console.log('AppointmentBookActionsServices:displayCombinedNote', arguments);

        if (aggregatedNotes) {
            return meevoNoteService.showNotes(aggregatedNotes);
        }

        function getAppointmentNote(appointmentNote: any, anyNotCheckedInServicesForCheckOut: boolean): string {
            if (anyNotCheckedInServicesForCheckOut &&
                appointmentNote &&
                appointmentNote.noteText &&
                (appointmentNote.isAppointmentType || appointmentNote.isRegisterType)
            ) {
                return appointmentNote.noteText;
            }

            return null;
        }

        return getAggregatedNotes(noteClient, noteServices, noteViewTime, isCheckingOut, anyNotCheckedInServicesForCheckOut)
            .then((aggregatedNotes) => {
                //console.log('response from AppointmentBookActionsServices:getAggregatedNotes', aggregatedNotes);
                const notes: Meevo.Plugins.Note.INote[] = [];

                if (appointmentNoteList && appointmentNoteList.length > 0) {
                    let logUsage = false;

                    for (const note of appointmentNoteList) {
                        note.isAppointmentType = note.noteType === Meevo.Model.AppointNoteTypeEnum.Checkin;
                        note.isRegisterType = note.noteType === Meevo.Model.AppointNoteTypeEnum.CheckinRegister && !isCheckingOut;
                        const appointmentNoteText = getAppointmentNote(note, anyNotCheckedInServicesForCheckOut)
                        if (appointmentNoteText) {
                            const newNote: Meevo.Plugins.Note.INote = {
                                id: note.id,
                                entityId: note.id,
                                clientGlobalId: noteClient.clientId,
                                clientType: noteClient.clientType,
                                displayName: note.displayName,
                                noteText: appointmentNoteText,
                                isAppointmentType: note.isAppointmentType,
                                isRegisterType: note.isRegisterType,
                                isAppointmentNote: true,
                                isNewNote: true,
                                isGroupedNote: false,
                                originalNote: note,
                            };
                            notes.push(newNote);
                            logUsage = true;
                        }
                    }

                    if (logUsage) {
                        meevoNoteService.usageTrackingLog(Meevo.Model.NounEnum.AppointmentBook, Meevo.Model.VerbEnum.AppointmentNotesViewed);
                    }
                }

                for (const aggregatedNote of aggregatedNotes) {
                    if (aggregatedNote.isClientNote) {
                        notes.push(aggregatedNote);
                        meevoNoteService.usageTrackingLog(Meevo.Model.NounEnum.AppointmentBook, Meevo.Model.VerbEnum.ClientNotesViewed);
                    }

                    if (aggregatedNote.isMembershipNote) {
                        notes.push(aggregatedNote);
                        meevoNoteService.usageTrackingLog(Meevo.Model.NounEnum.AppointmentBook, Meevo.Model.VerbEnum.MembershipNotesViewed);
                    }

                    if (aggregatedNote.isServiceNote) {
                        notes.push(aggregatedNote);
                        meevoNoteService.usageTrackingLog(Meevo.Model.NounEnum.AppointmentBook, Meevo.Model.VerbEnum.ServiceNotesViewed);
                    }
                }

                return meevoNoteService.showNotes(notes);
            });
    }

    //End AB and Client Notes

    var service = {
        editBlockChoice: 1,
        editAppointmentChoice: 1,
        viewAppointmentChoice: 1,
        details: undefined,
        block: undefined,
        originalAppointment: undefined,
        appointHeaderDelete: undefined,
        deleteAppointReason: undefined,
        appointmentServiceIdsToDelete: undefined,
        pendingAppointmentService: undefined,
        closeToggleCutCopy: true,
        isNewBookingAllowed: true,

        validateNewBook: function(dataTypeId) {
            var isOpen = helper.isEditorOpen(true);
            if (!isOpen) {
                if (!globals.fromDoubleBook) {
                    helper.CheckForDoubleBookWarning(dataTypeId == globals.appointmentDataTypeId).then(response => {
                        if (response.result == Meevo.Model.MessageBoxButtonResult.No) {
                            globals.divNewBooking.hide();
                            globals.divCellHighlight.hide();
                            return;
                        } else {
                            service.showEditor(dataTypeId);
                        }
                    });
                } else {
                    service.showEditor(dataTypeId);
                }
                globals.fromDoubleBook = false;
            } else {
                globals.divNewBooking.hide();
                globals.divCellHighlight.hide();
            }
        },
        showEditor: function(type) {
            globals.divNewBooking.hide();
            globals.divCellHighlight.hide();

            var data: any = {};

            if (globals.highlightedCell != undefined && globals.highlightedCell != null) {
                data = {
                    startTime: globals.highlightedCell.time,
                    date: globals.highlightedCell.date,
                    appointmentBookIncrement: $rootScope.appointmentBookIncrement,
                };

                var column: any = _.where(globals.columnBookings, {
                    columnId: helper.GetColumnId(globals.highlightedCell.date, globals.highlightedCell.entityId),
                })[0];
                if (column) {
                    if (globals.isEmployeeView) {
                        data.employee = {
                            id: globals.highlightedCell.entityId,
                            displayName: column.displayName,
                        };
                    } else {
                        data.resource = {
                            id: column.resourceId,
                            unitId: column.resourceUnitId,
                            displayName: column.displayName,
                            shortcut: column.shortcut,
                        };
                        let schedule = helper.getScheduleForCell(globals.highlightedCell, column);
                        if (schedule && schedule.employeeId) {
                            data.employee = {
                                id: schedule.employeeId,
                                displayName: schedule.employeeDisplayName,
                            };
                        }
                    }
                } else {
                    data = {
                        startTime: moment().startOf('day'),
                        date: moment(filterActions.dateString).format('M-D-YYYY'),
                    };
                }
            } else {
                data = {
                    startTime: moment().startOf('day'),
                    date: moment(filterActions.dateString).format('M-D-YYYY'),
                };
            }

            if (type == globals.appointmentDataTypeId) {
                $('body').focus(); // For Internet Explorer.
                $('#appointmentEditorForm #editor_maximized').hide();
                $rootScope.$broadcast('newAppointment', data);
                $mdSidenav('right').open();
            } else {
                $('body').focus(); // For Internet Explorer.
                $('#blockEditorFormInner').hide();
                $rootScope.$broadcast('newBlock', data);
                $mdSidenav('blockEditor').open();
            }

            $rootScope.$watch(
                'isSidenavOpen',
                (isSidenavOpen: any): void => {
                    this.CheckForAdjustEditor();
                }
            );
        },
        CheckForAdjustEditor: function() {
            const appointmentEditorId = '#appointmentEditorForm';
            const blockEditorId = '#blockEditorForm';
            if ($(appointmentEditorId).length > 0 && $mdSidenav('right').isOpen()) {
                service.AdjustEditor(appointmentEditorId, 'right');
            } else if ($(blockEditorId).length > 0 && $mdSidenav('blockEditor').isOpen()) {
                service.AdjustEditor(blockEditorId, 'blockEditor');
            } else {
                service.AdjustEditor(null, null);
            }
        },
        AdjustEditor: function(editor, sideNavName) {
            let modalWidth = $('#divCutCopy').is(':visible') ? 250 : 0;

            if (editor != null && $mdSidenav(sideNavName).isOpen()) {
                const editorWidth = $(editor).width();

                $('#standardCellTopRight').css('width', `${editorWidth + modalWidth + globals.timeColumnWidth}px`);

                $('#divAppointmentBookScrollContainer').css('width', `calc(100% - ${editorWidth + modalWidth + 100}px)`);

                $('#timeContainerRight').css('right', `${editorWidth + modalWidth}px`);

                if (modalWidth > 0) {
                    $('#divCutCopy').css('right', `${editorWidth}px`);
                }
            } else {
                modalWidth += globals.timeColumnWidth;
                if ($('#timeContainerRight').is(':visible')) {
                    modalWidth += globals.timeColumnWidth;
                }

                $('#standardCellTopRight').css('width', `${modalWidth - globals.timeColumnWidth}px`);

                $('#divAppointmentBookScrollContainer').css('width', `calc(100% - ${modalWidth}px)`);

                $('#timeContainerRight').css('right', `${modalWidth - globals.timeColumnWidth * 2}px`);

                $('#divCutCopy').css('right', '0px');
            }

            $timeout(() => {
                helper.setHeaderCellRootWidth();
            });
        },

        cutCopyMaximize() {
            service.closeToggleCutCopy = !service.closeToggleCutCopy
            if (service.closeToggleCutCopy) {
                $('.cutCopy-minimized').css('display', 'none')
                $('#divCutCopy').css('width', '250px');
                $('#cutCopy_maximized').show();
                globals.showHideCutCopyContainer()
            } else {
                $('.cutCopy-minimized').css('display', 'flex')
                $('.cutCopy-minimized').css('width', '18px')
                $('#divCutCopy').css('width', '18px');
                $('#cutCopy_maximized').hide();
                globals.showHideCutCopyContainer()

                //$('#divAppointmentBookScrollContainer').css('width', `calc(100% - 68px)`);
                //$('#divRootHeaders').css('width', 'calc(100% - 68px)');
            }
        },

        rebook() {
            restServer.getAppointment(service.details.appointmentId, true, true).then(response => {
                this.details = null;
                helper.hideSmartAssistant();
                let items: Meevo.Plugins.Register.RebookItem[] = [];
                response.data.services.forEach(service => {
                    if (service.clientType == Meevo.Model.ClientTypeEnum.Client) {
                        items.push({
                            appointmentServiceId: service.id,
                            employee: service.employee,
                            client: {
                                id: service.clientId,
                                displayName: service.clientDisplayName,
                            },
                            service: {
                                id: service.serviceId,
                                displayName: service.serviceDisplayName,
                                shortcut: service.serviceShortcut,
                            },
                            serviceDate: service.startDateTime,
                        });
                    }
                });
                rebookService.showRebookCandidates(items, false).then(candidates => {
                    if (candidates.length == 0) {
                        modalService.alert('MESSAGE_NO_QUALIFY_REBOOK');
                    }
                });
            });
        },
        manuallyRebook(appointmentServices) {
            $('#divClipboardRebook')
                .find('.cutcopyWrapper')
                .remove();
            appointmentServices.forEach(appointmentService => {
                appointmentService.sourceAppointmentServiceId = appointmentService.id;
                appointmentService.id = Meevo.Guid.newGuid().toString();
                CutCopyWorker(Meevo.Model.ClipboardActionEnum.Rebook, appointmentService, {
                    services: [appointmentService],
                });
            });
        },
        GetOpenModalWidth: function() {
            let modalWidth = globals.timeColumnWidth;
            if ($('#timeContainerRight').is(':visible')) {
                modalWidth += globals.timeColumnWidth;
            }

            if ($('#appointmentEditorForm #editor_maximized').is(':visible')) {
                modalWidth += $('#appointmentEditorForm #editor_maximized').width();
            } else if ($('#blockEditorForm').is(':visible')) {
                modalWidth += $('#blockEditorForm').width();
            } else if ($('#cutCopy_maximized').is(':hidden')) {
                modalWidth = $('#divCutCopy').outerWidth();
            }

            return modalWidth;
        },
        updateCellHighlight: function(cell) {
            if (!cell) {
                globals.divCellHighlight.hide();
                return;
            }

            if (!globals.highlightedCell ||
                cell.top != globals.highlightedCell.top ||
                cell.left != globals.highlightedCell.left) {
                globals.highlightedCell = cell;
                globals.divCellHighlight
                    .css('left', cell.left)
                    .css('top', cell.top)
                    .show();

                const columnWidth: any = $(`#${cell.columnId}`).width();
                globals.divCellHighlight.css('width', columnWidth);
            }

            if (cell) {
                setHighlightedCellTime(cell);
            }
        },
        initializeDraggable: function(booking, type) {
            globals.currentlyDraggableElement = undefined;
            globals.currentlyDraggableElement = booking.draggable({
                drag: function(event, ui) {
                    const scrollTopDiff = globals.scrollContainer.scrollTop() - globals.dragStartingScrollTop;
                    const scrollLeftDiff = globals.scrollContainer.scrollLeft() - globals.dragStartingScrollLeft;
                    ui.position.top += scrollTopDiff;
                    ui.position.left += scrollLeftDiff;

                    const cell = helper.GetCellByCoordinates(
                        event.pageX + scrollLeftDiff - globals.dragOffsetX,
                        event.pageY + scrollTopDiff - globals.dragOffsetY,
                        true,
                        globals.headerOffset,
                        0
                    );

                    service.updateCellHighlight(cell);
                },
                start: function(event, ui) {
                    globals.dragStartingScrollTop = globals.scrollContainer.scrollTop();
                    globals.dragStartingScrollLeft = globals.scrollContainer.scrollLeft();

                    // Only allow dragging if one of the details is open and not dragging from the gap
                    if (
                        (globals.divBlockDetails.is(':hidden') && globals.divAppointmentDetails.is(':hidden')) ||
                            $mdSidenav('right').isOpen() ||
                            $mdSidenav('blockEditor').isOpen() ||
                            $(event.toElement).hasClass('gap') ||
                            !service.canEditStartTime()
                    ) {
                        return false;
                    }

                    const $element = $(event.target);

                    $element.css('z-index', globals.zIndexDragging);

                    helper.cleanupPositionHelpers();
                    helper.hideSmartAssistant();

                    const clipboardAction = $element.data('clipboardAction');

                    if (
                        clipboardAction === Meevo.Model.ClipboardActionEnum.Cut ||
                        clipboardAction === Meevo.Model.ClipboardActionEnum.Copy
                    ) {
                        globals.dragOffsetX = event.offsetX;
                        globals.dragOffsetY = event.offsetY;
                        // if just a copy, need to make a clone of div to replace the one being moved
                        if (clipboardAction === Meevo.Model.ClipboardActionEnum.Copy) {
                            CopyAppointDetail($element, clipboardAction);
                        }
                    } else {
                        // Need to do it this way instead of using offset like above b/c for some reason position is different.  Need to investigate.
                        globals.dragOffsetX = event.pageX - $element.position().left - globals.timeColumnWidth;
                        globals.dragOffsetY = event.pageY - $element.position().top - globals.headerOffset;
                    }

                    booking.find('.ui-resizable-handle').remove();
                },
                stop: function(event, ui) {
                    const scrollTopDiff = globals.scrollContainer.scrollTop() - globals.dragStartingScrollTop;
                    const scrollLeftDiff = globals.scrollContainer.scrollLeft() - globals.dragStartingScrollLeft;
                    ui.position.top += scrollTopDiff;
                    ui.position.left += scrollLeftDiff;

                    helper.destroyDraggable();

                    globals.divCellHighlight.hide();

                    const cell = helper.GetCellByCoordinates(
                        event.pageX + scrollLeftDiff - globals.dragOffsetX,
                        event.pageY + scrollTopDiff - globals.dragOffsetY,
                        true,
                        globals.headerOffset,
                        0
                    );

                    const $element = $(event.target);

                    $element.css('height', $element.data('height'));

                    if (cell) {
                        // the drop cell isn't the same as the original cell of the booking so proceed with drop
                        const parentColumnId = $element.parent().attr('id');
                        if (parentColumnId != cell.columnId || ui.originalPosition.top != cell.top) {
                            CopyCutMove($element, cell, ui.originalPosition, true);
                            return;
                        }
                    }

                    // Drop coordinates outside of cell grid so just set dragged booking back to original position
                    $element.css({
                        'left': ui.originalPosition.left,
                        'top': ui.originalPosition.top,
                        'z-index': globals.zIndexBooking,
                    });

                    let copyReplaceId = $element.data('copyReplaceId');
                    if (copyReplaceId != undefined) {
                        $(`div[data-id='${copyReplaceId}']`).remove();
                    }
                },
                scroll: true,
            });
        },
        initializeResizable: function(booking, type) {
            if (!globals.businessInfo.enableStepDragging) {
                console.debug('Step Resizing not enabled by Business Setting.')
                return;
            }

            if (service.details && service.details.doNotAllowStepTimingOverride) {
                console.debug(`Step Resizing disabled due to service ${service.details.displayName} not allowing step timing override.`)
                return;
            }

            const columnBookingId = booking.data('id');
            const columnBooking = findColumnBooking(columnBookingId);

            if (!columnBooking) {
                console.error(`Step Resizing disabled due to column booking ${columnBookingId} missing.`)
                return;
            }

            if (service.details && service.details.isInPast && columnBooking.finalState !== Meevo.Model.AppointFinalStateEnum.CheckedOut) {
                console.debug('Step Resizing disabled in past unless appointment service is checked out.');
                return;
            }

            if (type === globals.appointmentDataTypeId) {
                if (!service.canEditCheckedOutService(columnBooking)) {
                    // canEditCheckedOutService will return false if not checked out, but in this case, pass through if not checked out
                    if (service.isCheckedOut(columnBooking.finalState)) {
                        console.debug('Step Resizing disabled due to service being checked out.')
                        return;
                    }
                }
            }

            const intervalHeight = helper.convertMinutesToPixels($rootScope.appointmentBookIncrement);
            const maxHeight = helper.convertMinutesToPixels(12 * 60); // 12 hour maximum

            let elements;
            const minHeight = intervalHeight;

            // because contiguous steps of same type may be merged in the DOM,
            // create invisible DOM elements to represent the individual steps
            // and add the resize handlers to those
            // these will get cleaned up along with the resize handles
            switch (type) {
                case globals.appointmentDataTypeId:
                    let top = 0;
                    let html = [];

                    booking.find('.appt-book-step-resize-structure').remove();

                    _(columnBooking.steps).each(step => {
                        if (step.durationWithAddOnsInMinutes > 0) {
                            const height = helper.convertMinutesToPixels(step.durationWithAddOnsInMinutes);
                            const minHeight = helper.convertMinutesToPixels(step.extendedByStepMinutes);
                            const div = `<div data-step-number="${step.serviceStepNumber}" data-min-height="${minHeight}" class="appt-book-step-resize-structure" style="top:${top}px;height:${height}px"></div>`;
                            top += height;
                            html.push(div);
                        }
                    });

                    booking.append(html);
                    elements = booking.find('.appt-book-step-resize-structure');
                    break;
                case globals.blockDataTypeId:
                    elements = booking;
                    break;
            }

            elements.append(`<div class="appt-book-step-resize-handle ui-resizable-handle ui-resizable-handle-s"></div>`);

            const durationFormat = $filter('durationFormat') as any;

            const normalizeHeight = (height: number) => {
                return height > 0
                    ? helper.normalize(height, intervalHeight)
                    : minHeight;
            };

            globals.currentlyResizableElements = undefined;
            globals.currentlyResizableElements = elements.resizable({
                handles: {
                    "s": '.ui-resizable-handle'
                },
                helper: "appt-book-step-resize-helper",
                minHeight: minHeight,
                maxHeight: maxHeight,

                resize: function(event, ui) {
                    const scrollTopDiff = globals.scrollContainer.scrollTop() - globals.dragStartingScrollTop;
                    const scrollLeftDiff = globals.scrollContainer.scrollLeft() - globals.dragStartingScrollLeft;

                    const $element = ui.element;

                    const top = type === globals.appointmentDataTypeId ? $element.position().top : 0;

                    const cell = helper.GetCellByCoordinates(
                        event.pageX + scrollLeftDiff - globals.dragOffsetX,
                        event.pageY + scrollTopDiff - globals.dragOffsetY + (top + ui.originalSize.height - 1),
                        true,
                        globals.headerOffset,
                        0
                    );

                    service.updateCellHighlight(cell);

                    const height = normalizeHeight(ui.size.height);
                    const elementMinHeight = $element.data('min-height'); // min-height is defined only for appointment steps
                    const stepMinHeight = elementMinHeight
                        ? Math.max(minHeight, +elementMinHeight)
                        : minHeight;
                    ui.size.height = Math.max(stepMinHeight, height);

                    if (cell && height > 0) {
                        const newDurationInMinutes = helper.convertPixelsToMinutes(ui.size.height);
                        $('.appt-book-step-resize-helper p').text(durationFormat(newDurationInMinutes));
                        let fontStyleAdjustment = helper.getDragResizingFontAdjustment(globals.columnWidthPercent);
                        if (fontStyleAdjustment!= '') {
                            $('.appt-book-step-resize-helper p').css('font-size', fontStyleAdjustment);
                        }
                    }

                    $('.appt-book-step-resize-helper')
                        .toggle(!!cell);
                },
                start: function(event, ui) {
                    globals.dragStartingScrollTop = globals.scrollContainer.scrollTop();
                    globals.dragStartingScrollLeft = globals.scrollContainer.scrollLeft();

                    // Only allow resizing if one of the details is open
                    if (
                        (globals.divBlockDetails.is(':hidden') && globals.divAppointmentDetails.is(':hidden')) ||
                            $mdSidenav('right').isOpen() ||
                            $mdSidenav('blockEditor').isOpen()
                    ) {
                        console.debug('Step Resizing disabled because Smart Assistant is not visible.')
                        return false;
                    }

                    const $element = ui.element;

                    let top = $element.position().top;
                    switch (type) {
                        case globals.appointmentDataTypeId:
                            top += booking.position().top;
                            break;
                    }

                    globals.dragOffsetX = 0;
                    globals.dragOffsetY = event.pageY - top - globals.headerOffset;

                    helper.cleanupPositionHelpers();
                    helper.hideSmartAssistant();

                    const resizeHelper = $('.appt-book-step-resize-helper');
                    resizeHelper.css('box-sizing', 'border-box');

                    $element.resizable('option', 'minWidth', ui.size.width);
                    $element.resizable('option', 'maxWidth', ui.size.width);

                    const height = normalizeHeight(ui.size.height);
                    if (height > 0) {
                        const durationInMinutes = helper.convertPixelsToMinutes(height);
                        resizeHelper.html(`<p>${durationFormat(durationInMinutes)}</p>`);
                    }
                },
                stop: function(event, ui) {
                    globals.divCellHighlight.hide();

                    const $element = ui.element;

                    $element.css({
                        'width': ui.originalSize.width,
                        'height': ui.originalSize.height,
                    });

                    helper.destroyResizable();

                    const height = normalizeHeight(ui.size.height);
                    const newDurationInMinutes = helper.convertPixelsToMinutes(height);
                    const stepNumber = $element.data('step-number');

                    service.resizableUpdateDuration(columnBooking, type, stepNumber, newDurationInMinutes);
                },
            });
        },
        resizableUpdateDuration: function(entity, type, stepNumber, newDurationInMinutes) {
            switch (type) {
                case globals.appointmentDataTypeId:
                    const appointmentId = entity.appointmentId;
                    restServer.getAppointment(appointmentId, false, true).then(result => {
                        const appointment: Meevo.Model.Appointment = result.data;
                        const appointmentService: Meevo.Model.AppointmentService = _(appointment.services).find(service => service.id == entity.id);
                        const appointmentServiceStep: Meevo.Model.AppointmentServiceStep = _(appointmentService.steps).find(step => step.serviceStepNumber == stepNumber);

                        const durationInMinutes = newDurationInMinutes - appointmentServiceStep.extendedByStepMinutes;

                        if (appointmentServiceStep.durationInMinutes == durationInMinutes) {
                            return $q.resolve();
                        }

                        appointmentService['service'] = {
                            id: appointmentService.serviceId,
                            displayName: appointmentService.serviceDisplayName,
                        };

                        const client = {
                            id: appointmentService.clientId,
                        };

                        stepOverrideService.initialize(appointmentService, client).then(() => {
                            appointmentServiceStep.durationInMinutes = durationInMinutes;
                            appointmentService.totalMinutes = _(appointmentService.steps).reduce((a, b) => a + b.durationInMinutes, 0);

                            return service.updateAppointmentServiceStepsWithWarnings(appointment, appointmentService, false).then(() => {
                                stepOverrideService.check(appointmentService, client).then(() => {
                                    stepOverrideService.save(appointmentService, client, appointmentId, Meevo.Model.NounEnum.Appointment);
                                });
                            });
                        });
                    });
                    break;

                case globals.blockDataTypeId:
                    const endDateTime = moment(entity.startDateTime).add(newDurationInMinutes, "minutes");

                    if (endDateTime.isSame(moment(entity.endDateTime))) {
                        return $q.resolve();
                    }

                    entity.endDateTime = endDateTime.toDate();

                    service.updateBlockDurationWithWarnings(entity);
                    break;
            }
        },
        canEditStartTime: function() {
            if (service.block) {
                if (service.block.isInPast) {
                    return false;
                }

                if (!service.isLocal(service.block.locationId)) {
                    return false;
                }

                return true;
            }

            if (service.details) {
                if (service.isCheckedOut()) {
                    const startDateTime = moment(service.details.startDateTime).startOf('day');
                    const cutoffDays = globals.businessInfo.maxDaysToAllowServiceStartTimeEdit;
                    const cutoffDate = startDateTime.add(cutoffDays, 'days');
                    if (helper.isInPast(cutoffDate)) {
                        return false;
                    }
                } else {
                    if (service.details.isInPast) {
                        return false;
                    }
                }

                if (!service.isLocal(service.details.locationId)) {
                    return false;
                }

                return true;
            }

            return false;
        },
        copyCutMoveRevertCallback: function(
            booking,
            originalTop,
            originalColumnId,
            destinationColumnId,
            clipboardAction
        ) {
            booking.css('top', originalTop);
            booking.css('z-index', globals.zIndexBooking);

            if (clipboardAction === Meevo.Model.ClipboardActionEnum.Cut || angular.isUndefined(clipboardAction)) {
                booking.detach();
                if (originalColumnId != undefined) {
                    // Would be the case if reverting a cut and the original column was no longer on the screen
                    booking.appendTo('#' + originalColumnId);
                }
            } else {
                booking.remove();
            }
            helper.AdjustColumnCellsForMultiBooking(destinationColumnId);
            helper.CalculatePercentageBookedForColumnId(destinationColumnId);
            if (originalColumnId != undefined) {
                helper.AdjustColumnCellsForMultiBooking(originalColumnId);
                helper.CalculatePercentageBookedForColumnId(originalColumnId);
            }
        },
        CopyCutMoveFinal: function(booking, cell, originalColumnId, fromDragAndDrop: boolean = false, copyCutMoveRevert) {
            let clipboardAction = booking.data('clipboardAction');
            if (clipboardAction == Meevo.Model.ClipboardActionEnum.Cut) {
                // remove hidden parent b/c don't need anymore
                globals.isPasting = false;
                $(`div[data-id='${booking.data('clipboardActionId')}']`)
                    .parent()
                    .remove();
            }

            if (clipboardAction == Meevo.Model.ClipboardActionEnum.Copy) {
                $(`div[data-id='${booking.data('id')}'] .confirm`)
                    .removeClass()
                    .addClass('confirm backRed');
                helper.setAppointStateIndicator(
                    booking.data('id'),
                    Meevo.Model.AppointStateEnum.Booked,
                    Meevo.Model.AppointFinalStateEnum.None
                );
            }

            globals.copyCutMoveBooking = booking;

            if (clipboardAction === Meevo.Model.ClipboardActionEnum.Copy) {
                let employeeId = globals.isEmployeeView ? cell.employeeId : booking.data('employeeId');
                let resourceUnitId = globals.isEmployeeView ? booking.data('resourceUnitId') : cell.entityId;
                let resourceId = globals.isEmployeeView ? undefined : cell.resourceId;
                globals.restrictedIds[booking.data("id")] = true;
                if (booking.data('type') == globals.appointmentDataTypeId) {
                    CopyWithWarnings(
                        booking.data('clipboardActionId'),
                        booking.data('appointmentId'),
                        booking.data('appointmentEntityVersion'),
                        cell.date,
                        cell.time,
                        employeeId,
                        resourceUnitId,
                        resourceId,
                        copyCutMoveRevert
                    );
                } else {
                    CopyAppointBlockWithWarnings(
                        booking.data('clipboardActionId'),
                        booking.data('blockEntityVersion'),
                        cell.date,
                        cell.time,
                        employeeId,
                        resourceUnitId,
                        resourceId,
                        copyCutMoveRevert
                    );
                }
            } else if (clipboardAction === Meevo.Model.ClipboardActionEnum.Rebook) {
                let employeeId = globals.isEmployeeView ? cell.employeeId : booking.data('employeeId');
                let resourceUnitId = globals.isEmployeeView ? booking.data('resourceUnitId') : cell.entityId;
                let resourceId = globals.isEmployeeView ? undefined : cell.resourceId;

                rebookWithWarnings(
                    booking.data('id'),
                    cell.date,
                    cell.time,
                    employeeId,
                    resourceUnitId,
                    resourceId,
                    copyCutMoveRevert
                );
            } else {
                globals.restrictedIds[booking.data("id")] = true;
                globals.isPasting = true;
                if (booking.data('type') == globals.appointmentDataTypeId) {
                    let employeeId = globals.isEmployeeView ? cell.employeeId : undefined;
                    let resourceUnitId = globals.isEmployeeView ? undefined : cell.entityId;
                    let resourceId = globals.isEmployeeView ? undefined : cell.resourceId;

                    const moveAppointmentService = () => {
                        MoveWithWarnings(
                            booking.data('id'),
                            booking.data('appointmentId'),
                            booking.data('appointmentEntityVersion'),
                            cell.date,
                            cell.time,
                            employeeId,
                            resourceUnitId,
                            resourceId,
                            originalColumnId,
                            fromDragAndDrop,
                            copyCutMoveRevert
                        );
                    }

                    if (fromDragAndDrop
                        && (globals.isMobile || device.tablet())
                        && globals.businessInfo.promptDragDropAppointmentOnMobile) {

                        modal.showMessage($translate.instant('MESSAGE_DRAG_DROP_APPOINTMENT_MOBILE'), {
                            buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                            callback: (result) => {
                                if (result == Meevo.Model.MessageBoxButtonResult.Yes) {
                                    moveAppointmentService();
                                } else {
                                    copyCutMoveRevert(booking.data('appointmentId'));
                                }
                            }
                        });
                        return;
                    }

                    moveAppointmentService();
                } else {
                    let employeeId = globals.isEmployeeView ? cell.employeeId : service.block.employeeId;
                    let resourceId = globals.isEmployeeView ? service.block.resourceId : cell.resourceId;
                    let copyCutMoveBooking = globals.copyCutMoveBooking;

                    MoveBlockWithWarnings(
                        booking.data('id'),
                        booking.data('blockEntityVersion'),
                        cell.date,
                        cell.time,
                        employeeId,
                        resourceId,
                        resp => {
                            globals.isPasting = false;
                            delete globals.restrictedIds[copyCutMoveBooking.data('id')];
                            onMoveBlockSuccess(booking, resp, originalColumnId);
                            modal.disposeCutCopyClipboardIfEmpty();
                        },
                        copyCutMoveRevert
                    );
                }
            }
        },
        appointmentBookClick: function(event) {
            event.preventDefault();

            globals.fromDoubleBook = false;

            if (globals.phoneMode) {
                return;
            }

            helper.cleanupPositionHelpers();
            helper.hideSmartAssistant();

            const timeCell = helper.GetCellByCoordinates(
                event.pageX,
                event.pageY,
                true,
                globals.headerOffset + globals.containerOffset - globals.scrollContainer.scrollTop(),
                globals.scrollContainer.scrollLeft()
            );

            service.isNewBookingAllowed = helper.verifyNewBookingAllowed(timeCell.date);

            setHighlightedCellTime(timeCell);

            service.details = undefined;
            service.block = undefined;

            if (
                globals.copyCutAppointmentServiceId == undefined ||
                $(`div[data-id='${globals.copyCutAppointmentServiceId}']`).html() == undefined
            ) {
                if (helper.clickedCellInPast(timeCell)) {
                    modalService.alert('MESSAGE_BOOK_APPOINTMENT_IN_PAST');
                    return;
                }

                if (!$mdSidenav('right').isOpen()) {
                    helper.showNewBooking(event);
                }
            } else {
                let nextCopyId;

                // if just a copy, need to make a clone of div to replace the one being moved
                const copyCutAppointDetail = $(`div[data-id='${globals.copyCutAppointmentServiceId}']`);
                if (
                    copyCutAppointDetail.data('clipboardAction') === Meevo.Model.ClipboardActionEnum.Copy ||
                    copyCutAppointDetail.data('clipboardAction') === Meevo.Model.ClipboardActionEnum.Rebook
                ) {
                    if (copyCutAppointDetail.data('clipboardAction') === Meevo.Model.ClipboardActionEnum.Copy &&
                        globals.isPasting) {
                        return;
                    }

                    nextCopyId = CopyAppointDetail(
                        copyCutAppointDetail,
                        copyCutAppointDetail.data('clipboardAction')
                    );
                }

                CopyCutMove(copyCutAppointDetail, timeCell, {
                    top: copyCutAppointDetail.position().top,
                    left: copyCutAppointDetail.position().left,
                });

                globals.copyCutAppointmentServiceId = nextCopyId;
            }
        },
        appointmentBookDoubleClick: function(event) {
            event.preventDefault();

            globals.fromDoubleBook = false;

            securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_ADDAPPOINTMENT)
                .then(result => {
                    if (result !== Meevo.Model.SecurityAccessEnum.Grant) {
                        return;
                    }

                    if (helper.isEditorOpen(true)) {
                        return;
                    }

                    if (globals.phoneMode) {
                        return;
                    }

                    helper.cleanupPositionHelpers();
                    helper.hideSmartAssistant();

                    const cell = helper.GetCellByCoordinates(event.pageX,
                        event.pageY,
                        true,
                        globals.headerOffset + globals.containerOffset - globals.scrollContainer.scrollTop(),
                        globals.scrollContainer.scrollLeft());

                    if (helper.clickedCellInPast(cell)) {
                        return;
                    }

                    if (!helper.verifyNewBookingAllowed(cell.date)) {
                        return;
                    }

                    helper.showNewBooking(event);

                    //always show the Appointment Editor on double click:
                    service.validateNewBook(globals.appointmentDataTypeId);
                    clearSelection();
                });
        },
        bookingClick: function(event, booking) {
            event.preventDefault();

            globals.fromDoubleBook = false;

            helper.destroyDraggable();
            helper.destroyResizable();

            helper.cleanupPositionHelpers();

            globals.currentActiveBooking = booking = $(booking);

            const id = booking.data('id');
            if (globals.restrictedIds[id]) {
                return;
            }

            const type: any = booking.data('type');

            globals.divCellHighlight.hide();
            globals.divNewBooking.hide();

            const parentColumn: any = _.findWhere(globals.columnBookings, { columnId: booking.parent().attr('id') });
            let loadPromise = null;

            if (type == globals.appointmentDataTypeId) {
                if ($(event.target).hasClass('gap')) {
                    helper.hideSmartAssistant();

                    const cell = helper.GetCellByCoordinates(
                        event.pageX,
                        event.pageY,
                        true,
                        globals.headerOffset + globals.containerOffset - globals.scrollContainer.scrollTop(),
                        globals.scrollContainer.scrollLeft()
                    );

                    if (globals.copyCutAppointmentServiceId == undefined) {
                        if (helper.clickedCellInPast(cell)) {
                            modalService.alert('MESSAGE_BOOK_APPOINTMENT_IN_PAST');
                            return;
                        }
                        service.details = undefined;
                        service.block = undefined;
                        helper.showNewBooking(event);
                        return;
                    } else {
                        let nextCopyId;
                        const copyCutAppointDetail = $(`div[data-id='${globals.copyCutAppointmentServiceId}']`);
                        // if just a copy, need to make a clone of div to replace the one being moved
                        if (copyCutAppointDetail.data('clipboardAction') == Meevo.Model.ClipboardActionEnum.Copy) {
                            nextCopyId = CopyAppointDetail(
                                copyCutAppointDetail,
                                copyCutAppointDetail.data('clipboardAction')
                            );
                        }
                        CopyCutMove(copyCutAppointDetail, cell, {
                            top: copyCutAppointDetail.position().top,
                            left: copyCutAppointDetail.position().left,
                        });
                        globals.copyCutAppointmentServiceId = nextCopyId;
                        return;
                    }
                }
                if (helper.isEditorOpen()) {
                    // do not bring up the Smart Assistant when an editor is open
                    return;
                }
                globals.divBlockDetails.hide();
                if (
                    globals.divAppointmentDetails.is(':visible') &&
                    (!service.details || booking.data('id') == service.details.id)
                ) {
                    globals.divAppointmentDetails.hide();
                    return;
                } else {
                    loadPromise = restServer.LoadAppointmentBookDetailPopup(
                        booking.data('id'),
                        onAppointmentBookDetailPopupSuccess,
                        parentColumn
                    );
                    globals.currentPopupDiv = globals.divAppointmentDetails;
                }
            } else {
                globals.divAppointmentDetails.hide();
                if (
                    globals.divBlockDetails.is(':visible') &&
                    (!service.block || booking.data('id') == service.block.id)
                ) {
                    globals.divBlockDetails.hide();
                    return;
                } else {
                    loadPromise = restServer.LoadAppointmentBookBlockPopup(
                        booking.data('id'),
                        onAppointmentBookBlockPopupSuccess,
                        parentColumn
                    );
                    globals.currentPopupDiv = globals.divBlockDetails;
                }
            }

            const continueExecution = () => {
                let permissionKey;
                switch (type) {
                    case globals.appointmentDataTypeId:
                        permissionKey = Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_EDITAPPOINTMENT;
                        break;
                    case globals.blockDataTypeId:
                        permissionKey = Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_EDITBLOCK;
                        break;
                }

                securityChecker.checkSecurityKey(permissionKey).then(result => {
                    if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                        if (
                            !globals.phoneMode &&
                            !helper.isEditorOpen() &&
                            (type == globals.blockDataTypeId ||
                                (
                                    (booking.attr('data-ts') && parseInt(booking.attr('data-ts')) != Meevo.Model.AppointStateEnum.Pending) &&
                                    (booking.attr('data-ts') && parseInt(booking.attr('data-ts')) != Meevo.Model.AppointStateEnum.WalkInPending)
                                )
                            )
                        ) {
                            service.initializeDraggable(booking, type);
                            service.initializeResizable(booking, type);
                        }
                    }
                });
            };

            if (loadPromise) {
                loadPromise.then(() => {
                    helper.positionPopup(globals.currentPopupDiv, booking, false);
                    continueExecution();
                });
            } else {
                continueExecution();
            }

            // Set position of highlighted cell to be used in double booking workflow.
            const bookingPosition = booking.position();
            globals.highlightedCell = helper.GetCellByCoordinates(bookingPosition.left, bookingPosition.top, false);
            if (globals.highlightedCell) {
                globals.divCellHighlight
                    .css('left', globals.highlightedCell.left + globals.timeColumnWidth)
                    .css('top', globals.highlightedCell.top + globals.headerOffset);
            }

            // bring forward the selected item to see the resize dragbars
            $('#divAppointmentBookContainer').find('.appointment, .block').css('z-index', globals.zIndexBooking);
            booking.css('z-index', globals.zIndexSelected);

            //save the original click event so it can be re-fired by doublebook
            globals.divCellHighlight.data('clickedEvent', event);
        },
        bookingDoubleClick: function(event, id) {
            event.preventDefault();

            globals.fromDoubleBook = false;

            if (globals.restrictedIds[id]) {
                return;
            }

            securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_EDITAPPOINTMENT)
                .then(result => {
                    if (result !== Meevo.Model.SecurityAccessEnum.Grant) {
                        return;
                    }

                    const booking = $(`div[data-id='${id}']`);
                    const cell = helper.GetCellByCoordinates(event.pageX,
                        event.pageY,
                        true,
                        globals.headerOffset + globals.containerOffset - globals.scrollContainer.scrollTop(),
                        globals.scrollContainer.scrollLeft());

                    if (helper.clickedCellInPast(cell)) {
                        return;
                    }

                    const type: any = booking.data('type');
                    switch (type) {
                        case globals.appointmentDataTypeId:
                            if (
                                service.details &&
                                (service.details.transitionState == Meevo.Model.AppointStateEnum.Pending ||
                                    service.details.transitionState == Meevo.Model.AppointStateEnum.WalkInPending ||
                                    service.details.isInPast)
                            ) {
                                return;
                            }

                            if ($(event.target).hasClass('gap')) {
                                service.appointmentBookDoubleClick(event);
                                return;
                            }

                            service.openAppointment({
                                id: booking.data('id'),
                                appointmentId: booking.data('appointmentId'),
                                appointmentServiceScheduleId: booking.data('appointment-service-schedule-id'),
                                finalState: booking.data('fs'),
                            });
                            break;

                        case globals.blockDataTypeId:
                            if (
                                service.block &&
                                (service.block.id || service.block.blockScheduleId) &&
                                service.isLocal(service.block.locationId)
                            ) {
                                service.editBlock(service.block);
                            }
                            break;
                    }
                });
        },
        getWorkTicketSelectorClass() {
            if (globals.isMobile) {
                return 'divWorkTicketSelectorMobile';
            }
            if (globals.divAppointmentDetails) {
                // width of WTS cannot be retrieved until it's open, which happens after this logic passes, so need to use pre-calculated number
                // which is width of WTS in open state. (65 (button image width) + 2x12 (inline button padding) + 2x2.5 (button border) + 2x8 (selector padding))
                const workTicketSelectorWidth = 110;
                let scrollContainerWidth = globals.scrollContainer.width();
                let scrollBarWidth = scrollContainerWidth - globals.scrollContainer.get(0).clientWidth;
                let wtsDivPositionStart = globals.divAppointmentDetails.position().left + globals.divAppointmentDetails.width();
                if (wtsDivPositionStart + workTicketSelectorWidth + scrollBarWidth > scrollContainerWidth) {
                    return 'divWorkTicketSelectorWrapped';
                }
            }
            return 'divWorkTicketSelector';
        },
        showWorkTicketSelector($event) {
            // on touch devices, this event handler gets called sporadically for "touchend" and/or "click"
            // there is no way around this due to the mix of installed libraries colliding with each other
            // touchend event occurs before General.ts hideCurrentPopup mouseup handler, while click occurs after
            // add sufficient delay to touchend handler to ensure it occurs after hideCurrentPopup mouseup handler
            $timeout(() => {
                $('#divWorkTicketSelector').css('z-index', globals.zIndexPopup).show();
                let workTicketPrintIcon = $('.wt-print-highlight > .wt-print > svg > path');
                workTicketPrintIcon.css('fill', '#ec2a7c');
                globals.currentPopupId = "divWorkTicketSelector";
            }, $event.type === 'touchend' ? 300 : 0);
        },
        printWorkTicketReport(reportId: number): ng.IPromise<any> {
            let data: any = {
                employeeId: service.details.employeeId,
                date: service.details.startDateTime,
                clientId: service.details.clientId,
                shortCut: reportId == 1 ? 'AQ020' : 'AQ022'
            };

            //AQ020 = 1 (large) / AQ022 = 2 (small)
            var reportModelParams = reportId == 1 ?
                "\"NoOfClientVisitNotes\":10," +
                "\"NoOfServiceHistory\":21," +
                "\"NoOfRetailHistory\":21," +
                "\"NoOfTodaysAppointments\":15," +
                "\"NoOfFutureAppointments\":5,"
                :
                "\"NoOfClientVisitNotes\":3," +
                "\"NoOfServiceHistory\":5," +
                "\"NoOfRetailHistory\":5," +
                "\"NoOfTodaysAppointments\":10," +
                "\"NoOfFutureAppointments\":3,";

            var reportParams = "{" +
                "\"ViewPurchaseOrdersReportBy\":\"InvoiceMode\"," +
                "\"ClientSelector_TBL\":[\"" + data.clientId + "\"]," +
                "\"EmployeeCList_TBL\":[\"" + data.employeeId + "\"]," +
                "\"StartDate\":\"" + moment(data.date).startOf("day").format("YYYY-MM-DD HH:mm:ss.SSS") + "\"," +
                "\"EndDate\":\"" + moment(data.date).endOf("day").format("YYYY-MM-DD HH:mm:ss.SSS") + "\"," +
                "\"showInactiveEmployees\":true," +
                "\"ServiceCategoryList_TBL\":[]," +
                "\"ServiceList_TBL\":[]," +
                "\"ServiceCategoryList_TBL\":[]," +
                "\"OrderTicketsBy\":\"ClientName\"," +
                "\"DisplayClientPhotos\": false," +
                "\"isAllSelected\":false," +
                "\"isServicesAllSelected\":true," +
                reportModelParams +
                "\"clientSortOrderEnum\":2133" +
                "}";

            var parameterData = {
                "reportId": reportId,
                "id": reportId,
                "shortCut": data.shortCut,
                "reportParams": reportParams,
                "reportFormat": "PDF",
                "reportContentType": "application/pdf",
                "sessionId": identityService.current().sessionId,
            };

            let url = `${identityService.current().systemSettings.reportsUrl}Report/LoadWorkTicketReport/${reportId}`;
            // ADO #131498 — the Prism modal frame is tied to the enhanced Appointment Book
            // gate (enhancedBookingMode + enableEnhancedBookingModeAtLocation/CentralOffice
            // + the user's experience choice). Legacy renders the original purple chrome.
            return $q.all({
                report: dataService.customMethodData(url, "POST", parameterData),
                refreshedChrome: $q.resolve(webComponentRegistry.isEnabled('appointment-book')).catch(() => false),
            }).then((resolved: any) => {
                var refreshedChrome = resolved.refreshedChrome === true;
                var pdf = resolved.report.data;
                var arrrayBuffer = this.base64ToArrayBuffer(pdf);
                var blob = new Blob([arrrayBuffer], { type: "application/pdf" });
                var pdfUrl = window.URL.createObjectURL(blob);

                let modalOptions: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/AppointmentBook/views/workTicketReport.html",
                    controller: 'meevo.plugins.appointmentbook.WorkTicketController',
                    controllerAs: 'vm',
                    bindToController: true,
                    // ADO #122500 — class lets handlePrintAppointment (AB Refresh path) target
                    // this specific md-dialog-container and raise its z-index above the
                    // AB Refresh side-panel (--prism-z-index-side-panel: 1000).
                    additionalClassName: refreshedChrome
                        ? 'print-report-dialog print-report-dialog--refresh'
                        : 'print-report-dialog',
                    locals: {
                        pdfUrl: pdfUrl,
                        label: reportId == 1 ? 'LABEL_RECEIPT_WORK_TICKET_LARGE' : 'LABEL_RECEIPT_WORK_TICKET_SMALL',
                        refreshedChrome: refreshedChrome
                    },
                };
                return modalService.showCustom(modalOptions);
            });
        },
        arrayBufferToBase64(buffer) {
            var binary = '';
            var bytes = new Uint8Array(buffer);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        },
        base64ToArrayBuffer(base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes;
        },
        printWorkTicketFromBook(workTicketType: any = null) {
            //AQ022 = 2 - small || AQ020 = 1 - large
            if (workTicketType && workTicketType === 2 || workTicketType === 1) {
                helper.cleanupPositionHelpers();
                helper.hideSmartAssistant();
                this.printWorkTicketReport(workTicketType).then(() => {

                    getAppointmentBookSettings().then(result => {
                        promptCheckIn();
                    });
                });
            }
            else {
                this.printWorkTicket(service.details.appointmentId).then(() => {
                    helper.cleanupPositionHelpers();
                    helper.hideSmartAssistant();

                    getAppointmentBookSettings().then(result => {
                        promptCheckIn();
                    });
                });
            }

            /**
            * Prompt client to check-in after printing work ticket if 'promptCheckInOnPrintInWorkTickets' is turned on
            */
            function promptCheckIn() {
                if (appointmentBookSettings.workTicketPromptCheckInOnPrint) {
                    if (
                        service.details.transitionState !== Meevo.Model.AppointStateEnum.CheckedIn &&
                        !service.isCheckedOut() &&
                        !service.details.isAppointmentInFuture
                    ) {
                        //is it checked in or checked out? if no then ask to check in

                        const message = $translate.instant('MESSAGE_WORK_TICKET_CHECK_IN_CLIENTS_AFTER_PRINT');
                        const details = angular.extend(service.details);

                        modal
                            .showMessage(message, { buttonsType: Meevo.Model.ButtonTypeEnum.YesNo })
                            .then(response => {
                                if (response.result === Meevo.Model.MessageBoxButtonResult.Yes) {
                                    service.details = details; //context is lost after the prompt is displayed, add details back in.
                                    service.checkedIn();
                                }
                            });
                    }
                }
            }
        },
        printWorkTicket(appointmentId): ng.IPromise<void> {
            const params = {
                appointmentId: appointmentId,
                locale: appSettings.APP_COUNTRYID,
                timeFormat: appSettings.APP_TIME_FORMAT
            };
            return printService.printCustom({ url: 'api/Report/AQ022', method: 'GET', params: params });
        },
        // ADO #122500 — exposed so the AB-Refresh WC `printDispatch` handler in
        // appointmentBook.webComponent.run.ts can fetch the BP value needed to
        // feed `viewPanel.appointmentBookSettings` before calling `onPrintSucceeded`.
        getAppointmentBookSettings(): ng.IPromise<Meevo.Model.AppointmentBookSettings> {
            return getAppointmentBookSettings();
        },
        // ADO #122500 — AB Refresh variant of printWorkTicket. Passes skipInterceptor:true
        // in query params so the global ExceptionInterceptor skips the legacy ALERT! dialog.
        // The WC surfaces errors via the printFailed @Input as a Prism error toast instead.
        printWorkTicketForRefresh(appointmentId: string): ng.IPromise<void> {
            const params = {
                appointmentId,
                locale: appSettings.APP_COUNTRYID,
                timeFormat: appSettings.APP_TIME_FORMAT,
                skipInterceptor: true,
            };
            return printService.printCustom({ url: 'api/Report/AQ022', method: 'GET', params });
        },
        canCut: () => {
            return this.canAddPermission && this.canEditPermission;
        },
        canViewCut: () => {
            return (
                angular.isDefined(service.details) &&
                !(service.isPending() || service.isWalkInPending()) &&
                service.canEditStartTime() &&
                this.canViewAddPermission &&
                this.canViewEditPermission
            );
        },
        canDoubleBook: () => {
            if (globals.isEmployeeView) {
                return this.canAddPermission;
            } else {
                return this.canAddPermission && this.canDoubleBookResourcePermission;
            }
        },
        canViewDoubleBook: () => {
            if (
                angular.isDefined(service.details) &&
                !(service.isPending() || service.isWalkInPending()) &&
                service.details &&
                !service.details.isInPast &&
                service.isLocal(service.details.locationId)
            ) {
                if (globals.isEmployeeView) {
                    return this.canViewAddPermission;
                } else {
                    let column: any = _.findWhere(globals.columnBookings, {
                        resourceUnitId: service.details.resourceUnitId,
                    });
                    return (
                        column &&
                        column.capacity == 0 &&
                        this.canViewAddPermission &&
                        this.canViewDoubleBookResourcePermission
                    );
                }
            }
            return false;
        },
        copyAppointment: function() {
            CutCopy(Meevo.Model.ClipboardActionEnum.Copy, Meevo.Model.MessageBoxButtonResult.No, true);
        },
        cutAppointment: function() {
            if (!service.canEditStartTime()) {
                modal.showMessage($translate.instant('MESSAGE_MOVE_CHECKED_OUT'));
                return;
            }

            CutCopy(Meevo.Model.ClipboardActionEnum.Cut, Meevo.Model.MessageBoxButtonResult.No, true);
        },
        copyBlock() {
            const blockId = service.block.id;
            const blockEntityVersion = service.block.entityVersion;

            removeExistingClipboardItem(service.block.id);
            helper.destroyResizable();

            const container = $('#divClipboardCopy');
            const padding = 10;
            const headerSpacing = 15;
            const newId = Meevo.Guid.newGuid().toString();

            const original = $(`div[data-id='${blockId}']`);
            let clone: JQuery;
            if (original.length > 0) {
                original.data('blockEntityVersion', blockEntityVersion);
                original.attr('data-block-entity-version', blockEntityVersion);

                clone = original.clone();
                clone.attr('data-block-id', blockId);
                clone.data('blockEntityVersion', blockEntityVersion);
                clone.attr('data-block-entity-version', blockEntityVersion);
                clone.attr('data-id', newId);

                clone.css('border', '0px'); // Remove border property of standardCell class.  Can't remove class but its needed when actually copying
            }

            clone.css({ top: 'auto', left: padding / 2, width: globals.columnWidth });
            clone.data('clipboardAction', Meevo.Model.ClipboardActionEnum.Copy);
            clone.data('clipboardActionId', blockId);

            globals.cutCopyIds.push({ id: newId, appointmentServiceId: blockId, isPasted: false });

            const height = clone.height() + padding + headerSpacing;
            const width = clone.width() + padding;
            const parentDiv = clone
                .wrap(
                    `<div class="cutcopyWrapper cutcopyBlock" style="position:relative;margin:10px;height:${height}px;width:${width}px;"></div>`
                )
                .parent();

            const unassignedEmployee = $translate.instant('LABEL_UNASSIGNED_EMPLOYEE');
            const employeeCode = service.block.employee ? service.block.employee.code : unassignedEmployee;
            parentDiv.prepend(`<div class="clipboardleft">${employeeCode}</div>`);

            const blockStartDate = meevoDateFilterFilter(moment(service.block.startDateTime).toDate());
            const blockStartTime = meevoTimeFilterFilter(moment(service.block.startDateTime).toDate());
            parentDiv.prepend(`<div class="clipboardright">${blockStartDate} ${blockStartTime}</div>`);

            parentDiv.appendTo(container);
            container.find('.cutCopyHeader').show();

            $('.cutcopyBlock')
                .unbind()
                .click(function() {
                    $('.cutcopyWrapper').removeClass('divSelected');
                    $(this).addClass('divSelected');
                    globals.copyCutAppointmentServiceId = $(this).find('.block').data('id');
                });

            parentDiv.find("img[class='blockDefIndicator']").remove();

            modal.showCutCopyClipboard();

            $('.divBlockDetails').hide();
        },
        onConfirmStateChangeSuccess: (appointment, response) => {
            service.updateConfirmState(
                service.details.appointmentId,
                response.entityVersion,
                response.confirmState
            );

            service.details.displayNameLastConfirmed = identityService.current().userName;
            service.details.lastConfirmDateDisplay = meevoDateFilterFilter(moment().toDate());

            helper.cleanupPositionHelpers();
            helper.hideSmartAssistant();

            $rootScope.$broadcast('updateAppointmentOverlays', {});
        },
        updateConfirmState: (appointmentId, appointmentEntityVersion, confirmState) => {
            globals.columnBookings.forEach(function(columnBooking) {
                var matchingServices = _.where(columnBooking.appointmentServices, { appointmentId: appointmentId });
                matchingServices.forEach(function(matchingService: any) {
                    $(`div[data-id='${matchingService.id}']`)
                        .data('appointmentEntityVersion', appointmentEntityVersion)
                        .find(' .confirm')
                        .attr('class', `confirm ${helper.getConfirmClass(confirmState)}`);
                    let rescheduleRequestClass = 'rescheduleRequest';
                    let step = $(`div[data-id='${matchingService.id}']`).data('appointmentEntityVersion', appointmentEntityVersion).find(' .step');
                    if (helper.isRescheduleRequest()) {
                        step.addClass(rescheduleRequestClass);
                    } else {
                        step.removeClass(rescheduleRequestClass);
                    }
                    matchingService.appointmentConfirmState = confirmState;
                });
            });
        },
        confirmAppointment: function() {
            restServer.confirmAppointment(
                service.details.appointmentId,
                service.details.appointmentEntityVersion,
                function(response) {
                    globals.columnBookings.forEach(function(columnBooking) {
                        var matchingServices = _.where(columnBooking.appointmentServices, {
                            appointmentId: service.details.appointmentId,
                        });
                        matchingServices.forEach(function(matchingService: any) {
                            $(`div[data-id='${matchingService.id}']`)
                                .data('appointmentEntityVersion', response.entityVersion)
                                .find(' .confirm')
                                .removeClass()
                                .addClass('confirm backGreen');
                        });
                    });

                    service.details.displayNameLastConfirmed = identityService.current().userName;
                    service.details.lastConfirmDateDisplay = meevoDateFilterFilter(moment().toDate());
                }
            );
        },
        unconfirmAppointment: function() {
            restServer.unConfirmAppointment(
                service.details.appointmentId,
                service.details.appointmentEntityVersion,
                function(response) {
                    globals.columnBookings.forEach(function(columnBooking) {
                        var matchingServices = _.where(columnBooking.appointmentServices, {
                            appointmentId: service.details.appointmentId,
                        });
                        matchingServices.forEach(function(matchingService: any) {
                            $(`div[data-id='${matchingService.id}']`)
                                .data('appointmentEntityVersion', response.entityVersion)
                                .find(' .confirm')
                                .removeClass()
                                .addClass('confirm backRed');
                        });
                    });

                    service.details.displayNameLastConfirmed = identityService.current().userName;
                    service.details.lastConfirmDateDisplay = meevoDateFilterFilter(moment().toDate());
                }
            );

            helper.cleanupPositionHelpers();
            helper.hideSmartAssistant();
        },
        showDocsAndForms() {
            restServer.getAppointment(service.details.appointmentId, true, true).then(result => {
                showDocsAndFormsWorker(
                    result.data.services,
                    Meevo.Plugins.AppointmentBook.FormCollectionStateEnum.SmartAssistant,
                    true,
                    true
                );
            });
            helper.hideSmartAssistant();
        },
        runningLate: function() {
            var newAppointState =
                service.details.transitionState == Meevo.Model.AppointStateEnum.RunningLate
                    ? Meevo.Model.AppointStateEnum.Booked
                    : Meevo.Model.AppointStateEnum.RunningLate;
            changeAppointmentServiceState(newAppointState);
        },
        unCheckIn() {
            let startDateMoment = moment(service.details.startDateTime);
            let startDate = startDateMoment.toDate().toDateString();
            let endDate = startDateMoment.add(1, 'd').toDate().toDateString();

            let searchCriteria: Meevo.Model.AppointmentServiceSearchCriteria = {
                clientId: service.details.clientId,
                startDate: startDate,
                endDate: endDate,
                transitionStates: [Meevo.Model.AppointStateEnum.CheckedIn],
                finalStates: [Meevo.Model.AppointFinalStateEnum.None],
                localAppointmentsOnly: true,
            };

            let request: Meevo.Model.AppointmentServicesPageWithLocation = {
                locationId: service.details.locationId,
                criteria: searchCriteria,
            };

            let multipleCheckInPrompt = appointmentServices => {
                modal.showMessage($translate.instant('MESSAGE_UNCHECK_IN_ALL_SERVICES'), {
                    buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                    callback: messageResult => {
                        if (messageResult === Meevo.Model.MessageBoxButtonResult.Yes) {
                            unCheckIn(appointmentServices);
                        } else {
                            unCheckIn([service.details]);
                        }
                    },
                });
            };

            let unCheckIn = appointmentServices => {
                let promise;

                if (appointmentServices.length === 1) {
                    promise = restServer.changeAppointmentServiceState(
                        service.details.id,
                        service.details.appointmentId,
                        service.details.appointmentEntityVersion,
                        Meevo.Model.AppointStateEnum.Booked,
                        service.details.startDateTime,
                        onChangeAppointDetailStateSuccess,
                        undefined,
                        true,
                        false
                    );
                } else {
                    let checkInMultipleRequest = {
                        AppointmentDate: startDate,
                        PatchLocalAppointmentsOnly: true,
                        model: {
                            TransitionState: Meevo.Model.AppointStateEnum.Booked,
                        },
                    };

                    promise = dataService.patch(
                        `client/${service.details.clientId}/appointmentservice`,
                        checkInMultipleRequest
                    );
                }

                helper.cleanupPositionHelpers();
                helper.hideSmartAssistant();

                return promise.then(()=> {
                    _(appointmentServices).each(appointmentService => {
                        helper.setAppointStateIndicator(
                            appointmentService.id,
                            Meevo.Model.AppointStateEnum.Booked,
                            Meevo.Model.AppointFinalStateEnum.None,
                            undefined,
                            false
                        );
                        appointmentService.transitionState = Meevo.Model.AppointStateEnum.Booked;

                        updateColumnBooking(appointmentService);
                    });

                    $rootScope.$broadcast('updateAppointmentOverlays', {});
                });
            };

            // un-checking in an anoymous client so no need to check if that client has other appointments today
            if (!service.details.clientId) {
                return unCheckIn([service.details]);
            }

            dataService
                .getListPaged('appointmentservicewithlocation', request)
                .then((appointmentServices: any[]) => {
                    if (appointmentServices.length === 1) {
                        unCheckIn([service.details]);
                    } else if (appointmentServices.length > 1) {
                        multipleCheckInPrompt(appointmentServices);
                    }
                });
        },
        checkedIn: function (onlyCheckNoShow: boolean = false, isCheckingOut: boolean = false) {
            if (service.details.transitionState == Meevo.Model.AppointStateEnum.CheckedIn && !isCheckingOut) {
                service.unCheckIn();
                return;
            }

            let startDateMoment = moment(service.details.startDateTime);
            let startDate = startDateMoment.toDate().toDateString();
            let endDate = startDateMoment.add(1, 'd').toDate().toDateString();

            let searchCriteria: Meevo.Model.AppointmentServiceSearchCriteria = {
                clientId: service.details.clientId,
                startDate: startDate,
                endDate: endDate,
                transitionStates: [
                    Meevo.Model.AppointStateEnum.Booked,
                    Meevo.Model.AppointStateEnum.NoShow,
                    Meevo.Model.AppointStateEnum.RunningLate,
                ],
                finalStates: [Meevo.Model.AppointFinalStateEnum.None],
                localAppointmentsOnly: true,
                includeAddOns: true,
            };

            let request: Meevo.Model.AppointmentServicesPageWithLocation = {
                locationId: service.details.locationId,
                criteria: searchCriteria,
                includeClient: true,
            };

            let multipleCheckInPrompt = (appointmentServices, isCheckingOut) => {
                return modal
                    .showMessage($translate.instant('MESSAGE_CHECK_IN_ALL_SERVICES'), {
                    buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                })
                .then(messageResult => {
                    if (messageResult.result === Meevo.Model.MessageBoxButtonResult.Yes) {
                        return checkIn(appointmentServices);
                    }

                    if (!isCheckingOut)
                        return checkIn([service.details]);
                });
            };

            let checkIn = (appointmentServices) => {
                let anyNotCheckedInServicesForCheckOut = service.getAnyNotCheckedInServicesForCheckOut(appointmentServices, isCheckingOut);
                return showDocsAndFormsWorker(appointmentServices)
                    .then(() => showCustomControls(appointmentServices, false, true))
                    .then(() => checkInApptServiceRequest())
                    .then(() => {
                        let appointmentGroups = _(appointmentServices).groupBy((value: any) => value.appointmentId + '#' + value.clientDisplayName);

                        let appointmentNotes = _.map(appointmentGroups, (group) => ({
                            appointmentId: group[0].appointmentId,
                            noteType: group[0].noteType,
                            noteText: group[0].noteText,
                            displayName: group[0].clientDisplayName
                        }));

                        const noteClient: Meevo.Plugins.Note.INoteClient = {
                            entityId: service.details.clientId,
                            clientId: service.details.clientId,
                            clientType: service.details.clientType,
                            clientDisplayName: service.details.clientDisplayName
                        };

                        const noteServices: Meevo.Plugins.Note.INoteService[] = [];
                        for (const appointmentService of appointmentServices) {
                            const noteService: Meevo.Plugins.Note.INoteService = {
                                entityId: appointmentService.serviceId,
                                serviceId: appointmentService.serviceId,
                            };

                            noteServices.push(noteService);

                            if (appointmentService.serviceAddOns) {
                                for (const serviceAddOn of appointmentService.serviceAddOns) {
                                    const noteService: Meevo.Plugins.Note.INoteService = {
                                        entityId: serviceAddOn.addOnServiceId,
                                        serviceId: serviceAddOn.addOnServiceId,
                                    };

                                    noteServices.push(noteService);
                                }
                            }
                        }

                        //console.log('checkedIn:checkIn -> displayCombinedNote');
                        return displayCombinedNote(appointmentNotes, noteClient, noteServices, undefined, isCheckingOut, anyNotCheckedInServicesForCheckOut, Meevo.Model.ClientNoteViewTimeEnum.CheckIn);
                    })
                    .finally(() => {
                        helper.cleanupPositionHelpers();
                        helper.hideSmartAssistant();
                    });

                function checkInApptServiceRequest(): ng.IPromise<any> {
                    let defer = $q.defer();

                    if (appointmentServices.length === 1) {
                        const onlyAppointmentService = appointmentServices[0];
                        let onWarningYes = () => {
                            restServer
                                .changeAppointmentServiceState(
                                    onlyAppointmentService.id,
                                    onlyAppointmentService.appointmentId,
                                    onlyAppointmentService.appointmentEntityVersion,
                                    Meevo.Model.AppointStateEnum.CheckedIn,
                                    onlyAppointmentService.startDateTime,
                                    (response) => {
                                        onChangeAppointDetailStateSuccess(response, false)
                                        defer.resolve();
                                    },
                                    undefined,
                                    true
                                );
                        }

                        let onChangeStateWarningLocal = (warnings) => {
                            onChangeStateWarning(warnings, onWarningYes)
                        }
                        restServer.changeAppointmentServiceState(
                            onlyAppointmentService.id,
                            onlyAppointmentService.appointmentId,
                            onlyAppointmentService.appointmentEntityVersion,
                            Meevo.Model.AppointStateEnum.CheckedIn,
                            onlyAppointmentService.startDateTime,
                            (response) => {
                                onChangeAppointDetailStateSuccess(response, false)
                                defer.resolve();
                            },
                            onChangeStateWarningLocal,
                            false
                        );
                    } else {
                        let checkInMultipleRequest = {
                            AppointmentDate: startDate,
                            PatchLocalAppointmentsOnly: true,
                            model: {
                                TransitionState: Meevo.Model.AppointStateEnum.CheckedIn,
                            },
                            SuppressWarnings: false
                        };

                        let onWarningYes = () => {
                            checkInMultipleRequest.SuppressWarnings = true;
                            dataService.patch(
                                'client/' + service.details.clientId + '/appointmentservice',
                                checkInMultipleRequest
                            ).then(() => {
                                defer.resolve();
                            })
                        }


                        dataService.patch(
                            'client/' + service.details.clientId + '/appointmentservice',
                            checkInMultipleRequest
                        ).then(data => {
                            if (data.isWarning) {
                                onChangeStateWarning(data.responseStatus.errors, onWarningYes);
                                return;
                            }
                            defer.resolve();
                        })
                    }

                    return defer.promise.then(() => {
                        _(appointmentServices).each(appointmentService => {
                            helper.setAppointStateIndicator(
                                appointmentService.id,
                                Meevo.Model.AppointStateEnum.CheckedIn,
                                Meevo.Model.AppointFinalStateEnum.None,
                                undefined,
                                false
                            );
                            appointmentService.transitionState = Meevo.Model.AppointStateEnum.CheckedIn;

                            if (service.details.id == appointmentService.id) {
                                service.details.transitionState = appointmentService.transitionState;
                            }

                            updateColumnBooking(appointmentService);

                            saveCustomControls(
                                appointmentService.customControlsAnswers,
                                appointmentService.id,
                                appointmentService.appointmentId,
                                appointmentService.id,
                                Meevo.Model.AppAreaEnum.Checkin
                            );
                        });

                        $rootScope.$broadcast('updateAppointmentOverlays', {});
                    });
                }
            };

            // checking in an anonymous client so no need to check if that client has other appointments today
            if (!service.details.clientId) {
                return checkIn([service.details]);
            }

            return dataService
                .getListPaged('appointmentservicewithlocation', request)
                .then((appointmentServices: any[]) => {
                    if (onlyCheckNoShow) {
                        const anyNoShowAppointmentServices = _(appointmentServices).any((service: any) => service.transitionState === Meevo.Model.AppointStateEnum.NoShow);
                        if (anyNoShowAppointmentServices) {
                            return multipleCheckInPrompt(appointmentServices, isCheckingOut);
                        } else {
                            return;
                        }
                    }

                    if (appointmentServices.length === 1) {
                        return checkIn([service.details]);
                    } else if (appointmentServices.length > 1) {
                        return multipleCheckInPrompt(appointmentServices, isCheckingOut);
                    }
                });
        },

        noShow: function() {
            let newAppointState = service.details.transitionState === Meevo.Model.AppointStateEnum.NoShow
                ? Meevo.Model.AppointStateEnum.Booked
                : Meevo.Model.AppointStateEnum.NoShow;

            changeAppointmentServiceState(newAppointState).then(() => {
                if (
                    newAppointState === Meevo.Model.AppointStateEnum.NoShow &&
                    service.details.clientType === Meevo.Model.ClientTypeEnum.Client &&
                    globals.businessInfo.enableIntegratedRegister &&
                    service.hasRegisterAccess()
                ) {
                    const hasDeposit = service.details.depositAmount;
                    const hasNoShowFee = globals.appointmentNoShowFeePercentage > 0;

                    if (hasNoShowFee || hasDeposit) {
                        const message = hasNoShowFee && hasDeposit
                            ? 'MESSAGE_PROCESS_NOSHOW_FEE_AND_DEPOSIT_REFUND'
                            : hasNoShowFee
                                ? 'MESSAGE_PROCESS_NOSHOW_FEE'
                                : 'MESSAGE_PROCESS_DEPOSIT_REFUND';

                        let options: Meevo.Components.Modal.IModalOptions = {
                            templateUrl: 'app/plugins/AppointmentBook/views/CancellationFeeConfirmationModal.html',
                            controller: 'meevo.plugins.appointmentBook.CancellationFeeConfirmationController',
                            controllerAs: 'vm',
                            bindToController: false,
                            locals: {
                                message: message,
                            },
                        };

                        return modalService.showCustom(options).then(choice => {
                            if (choice !== Meevo.Model.MessageBoxButtonResult.Yes) {
                                return;
                            }

                            return restServer.getAppointment(service.details.appointmentId).then(response => {
                                const appointmentService = _(response.data.services).findWhere({ id: service.details.id });

                                const checkOutServices = [];
                                const checkoutDetails = [];

                                if (hasNoShowFee) {
                                    const noShowFeeDetails = {
                                        type: Meevo.Model.SalesTypeEnum.ServiceNoShowFee,
                                        fee: globals.appointmentNoShowFeePercentage,
                                        applyToAddOns: globals.applyNoShowFeeToAddOns,
                                    };

                                    checkOutServices.push(appointmentService);
                                    checkoutDetails.push(noShowFeeDetails);
                                }

                                if (hasDeposit) {
                                    const depositDetail = {
                                        type: Meevo.Model.SalesTypeEnum.DepositCredit,
                                        appointmentServiceId: appointmentService.id,
                                        depositAmount: appointmentService.depositAmount,
                                        depositLocationId: appointmentService.depositLocationId,
                                        depositSaleDate: appointmentService.depositSaleDate,
                                        depositSaleId: appointmentService.depositSaleId,
                                        depositSaleLineId: appointmentService.depositSaleLineId,
                                    };

                                    checkOutServices.push(appointmentService);
                                    checkoutDetails.push(depositDetail);
                                }

                                service.gotoRegisterForCheckOut(
                                    appointmentService,
                                    response.data,
                                    checkOutServices,
                                    checkoutDetails
                                );
                            });
                        });
                    }
                }
            });
        },
        isCheckOutPastVisible: function(): boolean {
            if (!service.details.isInPast || !globals.businessInfo.enableIntegratedRegister) {
                return false;
            }

            const minDate = moment().startOf('day').subtract('days', globals.daysToEditTransaction);
            if (moment(service.details.startDateTime).isBefore(minDate)) {
                return false;
            }

            return true;
        },
        checkOutPastAppointmentService: function() {
            return modalService.confirm("MESSAGE_CHECKOUT_PAST_WARNING").then(() => {
                const pastTransactionCallback = (pastTransactionContext: Meevo.Model.PastTransactionContext) => {
                    this.checkOut(pastTransactionContext);
                };

                const modalOptions: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/transactionEditor/insertTransaction/insertTransactionModal.template.html",
                    controller: "meevo.plugins.transactionEditor.InsertTransactionModalController",
                    controllerAs: "vm",
                    bindToController: true,
                    locals: {
                        startDateTime: service.details.startDateTime,
                        isCheckout: true,
                        callback: pastTransactionCallback
                    }
                };

                return modalService.showCustom(modalOptions);
            });
        },
        checkOut: function(pastTransactionContext?: Meevo.Model.PastTransactionContext) {
            if (service.details.isInFuture) {
                modalService.alert('MESSAGE_CHECKOUT_FUTURE_APPOINTMENT');
                return;
            }
            if (service.details.transitionState == Meevo.Model.AppointStateEnum.NoShow) {
                modalService.confirmHandler('MESSAGE_APPOINTMENTBOOK_CHECKIN').then(response => {
                    if (response) {
                        this.checkedIn().then(() => {
                            this.doCheckOut(pastTransactionContext);
                        });
                    } else {
                        this.doCheckOut(pastTransactionContext);
                    }
                });
            } else {
                this.checkedIn(true, true).then(() => {
                    this.doCheckOut(pastTransactionContext);
                });
            }
        },
        doCheckOut: function(pastTransactionContext?: Meevo.Model.PastTransactionContext) {
            var trackingItem = new Meevo.Model.TrackingItem(
                Meevo.Model.NounEnum.AppointmentBookPage,
                Meevo.Model.VerbEnum.CheckoutButtonClicked,
                null,
                service.details.id
            );
            trackingService.saveTrackingInfo(trackingItem);

            if (globals.businessInfo.enableIntegratedRegister) {
                service.launchRegisterCheckout(service.details, pastTransactionContext);
                helper.cleanupPositionHelpers();
                helper.hideSmartAssistant();
            } else {
                modalService.confirm('MESSAGE_APPOINTMENTBOOK_CHECKOUT').then(() => {
                    service.checkoutAppointmentService(service.details);
                    helper.cleanupPositionHelpers();
                    helper.hideSmartAssistant();
                });
            }
        },
        checkoutAppointmentService: (appointmentService: any): void => {
            let startDateMoment = moment(appointmentService.startDateTime);
            let startDate = startDateMoment.toDate().toDateString();
            let endDate = startDateMoment.add(1, 'd').toDate().toDateString();
            let isMultipleCheckOut = false;

            addRecentClient(service.details);

            let sendCheckedOutMessage = (id: any, isMultipleCheckOut: boolean): void => {
                $rootScope.$broadcast(
                    Meevo.Components.Common.Messages.CLIENT_FIND_APPT_CHECKED_OUT,
                    id,
                    isMultipleCheckOut,
                    appointmentService.transitionState
                );
            };

            let checkoutSingleAppointmentService = (appointmentService: any): angular.IPromise<any> => {
                let checkOutSingleRequest = {
                    appointmentEntityVersion: appointmentService.appointmentEntityVersion,
                    model: {
                        TransitionState: appointmentService.transitionState,
                        FinalState: Meevo.Model.AppointFinalStateEnum.CheckedOut,
                    },
                };

                return dataService
                    .patch(
                        'appointment/' +
                            appointmentService.appointmentId +
                            '/appointmentservicecheckout/' +
                            appointmentService.id,
                        checkOutSingleRequest
                    )
                    .then(response => {
                        saveCustomControls(
                            appointmentService.customControlsAnswers,
                            response.saleLineId,
                            appointmentService.appointmentId,
                            appointmentService.id,
                            Meevo.Model.AppAreaEnum.Checkout
                        );
                        $rootScope.$broadcast('APPOINTMENT CHECKED OUT', null);
                    });
            };

            let checkoutMultipleAppointmentServices = (
                appointmentService: any,
                appointmentDate: any
            ): angular.IPromise<any> => {
                let checkOutMultipleRequest = {
                    locationId: appointmentService.locationId,
                    clientGlobalId: appointmentService.clientId,
                    appointmentDate: appointmentDate,
                    currentAppointmentServiceId: appointmentService.id,
                };

                return dataService.patch(
                    'client/' + appointmentService.clientId + '/appointmentservicecheckout',
                    checkOutMultipleRequest
                );
            };

            // for anonymous clients, only do a single appointment checkout

            if (!appointmentService.clientId) {
                showDocsAndFormsWorker([appointmentService]).then(() =>
                    showCustomControls([appointmentService], true, false).then(() => {
                        checkoutSingleAppointmentService(appointmentService).then(() => {
                            sendCheckedOutMessage(appointmentService.id, isMultipleCheckOut);
                        });
                    })
                );
                return;
            }

            let searchCriteria: Meevo.Model.AppointmentServiceSearchCriteria = {
                clientId: appointmentService.clientId,
                startDate: startDate,
                endDate: endDate,
                transitionStates: [
                    Meevo.Model.AppointStateEnum.Booked,
                    Meevo.Model.AppointStateEnum.Arrived,
                    Meevo.Model.AppointStateEnum.CheckedIn,
                    Meevo.Model.AppointStateEnum.RunningLate,
                    Meevo.Model.AppointStateEnum.NoShow,
                ],
                finalStates: [Meevo.Model.AppointFinalStateEnum.None],
                localAppointmentsOnly: true,
            };

            let request: Meevo.Model.AppointmentServicesPageWithLocation = {
                locationId: appointmentService.locationId,
                criteria: searchCriteria,
            };

            dataService
                .getListPaged('appointmentservicewithlocation', request)
                .then((unfilteredAppointmentServices: any[]) => {
                    let appointmentServices = unfilteredAppointmentServices.filter(
                        service =>
                            service.id === appointmentService.id ||
                            service.transitionState !== Meevo.Model.AppointStateEnum.NoShow
                    );

                    if (appointmentServices.length === 1) {
                        appointmentService.appointmentEntityVersion =
                            appointmentServices[0].appointmentEntityVersion;
                        showDocsAndFormsWorker([appointmentService]).then(() =>
                            showCustomControls([appointmentService], true, false).then(() => {
                                checkoutSingleAppointmentService(appointmentService).then(() => {
                                    sendCheckedOutMessage(appointmentService.id, isMultipleCheckOut);
                                });
                            })
                        );
                    } else if (appointmentServices.length > 1) {
                        modalService
                            .confirm('MESSAGE_APPOINTMENTBOOK_MULTIPLE_SERVICES')
                            .then(() => {
                                showDocsAndFormsWorker(appointmentServices).then(() =>
                                    showCustomControls(appointmentServices, true, false).then(() => {
                                        checkoutMultipleAppointmentServices(appointmentService, startDate).then(
                                            response => {
                                                let promises = [];
                                                response.forEach(appointmentService => {
                                                    promises.push(
                                                        saveCustomControls(
                                                            _.findWhere(appointmentServices, {
                                                                id: appointmentService.id,
                                                            }).customControlsAnswers,
                                                            appointmentService.saleLineId,
                                                            appointmentService.appointmentId,
                                                            appointmentService.id,
                                                            Meevo.Model.AppAreaEnum.Checkout
                                                        )
                                                    );
                                                });
                                                $q.all(promises).then(() => {
                                                    isMultipleCheckOut = true;
                                                    sendCheckedOutMessage(
                                                        appointmentService.appointmentId,
                                                        isMultipleCheckOut
                                                    );
                                                    $rootScope.$broadcast('APPOINTMENT CHECKED OUT', null);
                                                });
                                            }
                                        );
                                    })
                                );
                            })
                            .catch(() => {
                                showDocsAndFormsWorker([appointmentService]).then(() =>
                                    showCustomControls([appointmentService], true, false).then(() => {
                                        checkoutSingleAppointmentService(appointmentService).then(() => {
                                            sendCheckedOutMessage(appointmentService.id, isMultipleCheckOut);
                                        });
                                    })
                                );
                            });
                    }
                });
        },
        gotoRegisterForCheckOut: (
            initiatingService: any,
            data: any,
            checkOutServices: any[],
            checkOutDetails: any,
            pastTransactionContext?: Meevo.Model.PastTransactionContext
        ) => {
            const stateParams = {
                action: Meevo.Components.Common.Messages.CHECKOUT_APPT_SERVICES,
                appointmentId: initiatingService.appointmentId,
                appointmentEntityVersion: initiatingService.appointmentEntityVersion,
                id: initiatingService.id,
                isAnonymousClientCheckout: service.isAnonymousClient(initiatingService.clientType),
                services: checkOutServices,
                actionDetails: checkOutDetails,
                payingClient: {
                    firstName: data.payingClientFirstName,
                    lastName: data.payingClientLastName,
                    id: data.payingClientId,
                    displayName: data.payingClientLastName + ', ' + data.payingClientFirstName, // ???
                    primaryPhoneNumber: data.payingClientPhoneNumber,
                },
                pastTransactionContext: pastTransactionContext,
            };

            $rootScope.$broadcast('gotoState', { stateName: 'register', stateParams: stateParams });
        },
        getItemShowName(item: any) {
            return item.clientDisplayName;
        },
        getUniqueClientNames(services: any[]) {
            let dictionaryOfClientIds = [];
            var names = [];
            _.each(services, (item, index, arr) => {
                let key = item.clientType + '_' + (item.clientId ? item.clientId : '');
                if (!dictionaryOfClientIds[key]) {
                    dictionaryOfClientIds[key] = key;
                    names.push(service.getItemShowName(item));
                }
            });
            return names;
        },
        hasRegisterAccess(): boolean {
            return securityChecker.hasSecurity(Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
        },
        launchRegisterCheckout: (appointmentService, pastTransactionContext?: Meevo.Model.PastTransactionContext) => {
            if (!service.hasRegisterAccess()) {
                modal.showMessage($translate.instant('ERROR_HTTP_403'));
                return;
            }

            addRecentClient(appointmentService);

            const checkOutServices = [ appointmentService ];
            const checkOutDetails = [ {} ];

            if (appointmentService.transitionState === Meevo.Model.AppointStateEnum.NoShow) {
                if (globals.appointmentNoShowFeePercentage > 0) {
                    const noShowFeeDetail = {
                        type: Meevo.Model.SalesTypeEnum.ServiceNoShowFee,
                        fee: globals.appointmentNoShowFeePercentage,
                        applyToAddOns: globals.applyNoShowFeeToAddOns,
                    };

                    checkOutServices.push(appointmentService);
                    checkOutDetails.push(noShowFeeDetail);
                }

                if (appointmentService.depositAmount) {
                    const depositDetail = {
                        type: Meevo.Model.SalesTypeEnum.DepositCredit,
                        appointmentService: appointmentService,
                        appointmentServiceId: appointmentService.id,
                        depositAmount: -Math.abs(appointmentService.depositAmount),
                        serviceShortcut: appointmentService.serviceShortcut,
                        depositLocationId: appointmentService.depositLocationId,
                        depositSaleDate: appointmentService.depositSaleDate,
                        depositSaleId: appointmentService.depositSaleId,
                        depositSaleLineId: appointmentService.depositSaleLineId,
                    }

                    checkOutServices.push(appointmentService);
                    checkOutDetails.push(depositDetail);
                }
            } else {
                if (appointmentService.depositAmount) {
                    const depositDetail = {
                        type: Meevo.Model.PaymentSubCategoryEnum.DepositCharge,
                        appointmentService: appointmentService,
                        appointmentServiceId: appointmentService.id,
                        depositAmount: appointmentService.depositAmount,
                        serviceShortcut: appointmentService.serviceShortcut,
                    }

                    checkOutServices.push(appointmentService);
                    checkOutDetails.push(depositDetail);
                }
            }

            service.gotoRegisterForCheckOut(
                appointmentService,
                {},
                checkOutServices,
                checkOutDetails,
                pastTransactionContext
            );
        },
        deleteBlock: function(block) {
            if (globals.divBlockDetails) {
                globals.divBlockDetails.hide();
            }

            securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_BLOCKDEFINITION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE).then(securityResult => {
                if (block.id != undefined && 
                    block.blockScheduleId != undefined && 
                    securityResult !== Meevo.Model.SecurityAccessEnum.Hide &&
                    !this.block.isInPast) {
                    modal.showMessage('', {
                        buttonsType: Meevo.Model.ButtonTypeEnum.OkCancel,
                        customTemplateId: 'DeleteBlockDefinitionPrompt',
                        callback: function(result) {
                            if (result === Meevo.Model.MessageBoxButtonResult.Ok) {
                                if (service.editBlockChoice == 1) {
                                    service.deleteBlock({
                                        id: block.id,
                                        showSingleDeleteMessage: false,
                                        entityVersion: block.entityVersion,
                                    });
                                } else {
                                    if (securityResult === Meevo.Model.SecurityAccessEnum.Grant) {
                                        service.deleteBlock({
                                            blockScheduleId: block.blockScheduleId,
                                            blockScheduleEntityVersion: block.blockScheduleEntityVersion,
                                        });
                                    } else {
                                        modal.showMessage($translate.instant('MESSAGE_NOT_IN_SECURITY_ROLE'));
                                    }
                                }
                            }
                            service.editBlockChoice = 1;
                        },
                    });
                } else if (block.id != undefined) {
                    if (block.showSingleDeleteMessage) {
                        modal.showMessage($translate.instant('MESSAGE_DELETE_CONFIRMATION'), {
                            buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                            callback: function(result) {
                                if (result === Meevo.Model.MessageBoxButtonResult.Yes) {
                                    restServer.deleteAppointBlock(
                                        block.id,
                                        block.entityVersion,
                                        onDeleteAppointBlockSuccess
                                    );
                                }
                            },
                        });
                    } else {
                        restServer.deleteAppointBlock(block.id, block.entityVersion, onDeleteAppointBlockSuccess);
                    }
                } else {
                    dataService.customMethodData(`api/blockSchedule/${block.blockScheduleId}/existsToday`, 'GET', null).then((result: any) => {
                        let blockScheduleExistsToday = result.data;
                        if (blockScheduleExistsToday) {
                            modalService.confirmHandler('MESSAGE_STANDING_DEFINITION_BLOCK_DELETE_TODAY').then((response: boolean) => {
                                if (response) {
                                    dataService.objectStatePatch(
                                        'blockSchedule',
                                        block.blockScheduleId,
                                        block.blockScheduleEntityVersion,
                                        Meevo.Model.ObjectStateEnum.Deleted,
                                        undefined,
                                        'deleteToday'
                                    )
                                    .then(() => {
                                        filterActions.filterBook();
                                    });
                                } else {
                                    restServer.deleteBlockSchedule(
                                        block.blockScheduleId,
                                        block.blockScheduleEntityVersion,
                                        filterActions.filterBook()
                                    );
                                }
                            });
                        } else {
                            restServer.deleteBlockSchedule(
                                block.blockScheduleId,
                                block.blockScheduleEntityVersion,
                                filterActions.filterBook()
                            );
                        }
                    });
                }
            });
        },
        editBlock: function(block) {
            globals.divBlockDetails.hide();
            if (block.id != undefined && block.blockScheduleId != undefined && !this.block.isInPast) {
                modal.showMessage('', {
                    buttonsType: Meevo.Model.ButtonTypeEnum.OkCancel,
                    customTemplateId: 'EditBlockDefinitionPrompt',
                    callback: function(result) {
                        if (result == Meevo.Model.MessageBoxButtonResult.Ok) {
                            if (service.editBlockChoice == 1) {
                                service.editBlock({
                                    id: block.id,
                                });
                            } else {
                                service.editBlock({
                                    blockScheduleId: block.blockScheduleId,
                                });
                            }
                        }
                        service.editBlockChoice = 1;
                    },
                });
            } else if (block.id != undefined) {
                if (!helper.isEditorOpen(true)) {
                    $('body').focus(); // For Internet Explorer.
                    $('#blockEditorFormInner').hide();
                    $rootScope.$broadcast('editBlock', { blockId: block.id });
                    $mdSidenav('blockEditor').open();
                    $timeout(() => {
                        service.CheckForAdjustEditor();
                    });
                }
            } else {
                service.goToState(
                    'standingBlocks',
                    Meevo.Model.MaintenanceFormState.Editing,
                    block.blockScheduleId
                );
            }
        },
        deleteAppointment: function (appointmentService) {
            if (appointmentService.finalState == Meevo.Model.AppointFinalStateEnum.CheckedOut) {
                return modal.showMessage($translate.instant('MESSAGE_DELETE_CHECKED_OUT'));
            }

            let user = identityService.current();
            this.returnStateInfo = appointmentService.returnStateInfo;

            let meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
            securityChecker.checkSecurityKey(meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DELETEAPPOINTMENT).then(result => {
                if (result !== Meevo.Model.SecurityAccessEnum.Grant) {
                    return modal.showMessage($translate.instant('MESSAGE_NOT_IN_SECURITY_ROLE'));
                }

                securityChecker.checkSecurityKey(meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DELETEANYAPPOINTMENT).then(result => {
                    if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                        continueExecution(true);
                        return;
                    }

                    restServer.getAppointment(appointmentService.appointmentId).then(result => {
                        let currentAppointment = result.data;

                        let isDeleteAllowed = _(currentAppointment.services).some((appointmentService: any) => user.userId === appointmentService.employeeId);

                        if (!isDeleteAllowed) {
                            return modal.showMessage($translate.instant('MESSAGE_NOT_IN_DELETE_ANY_APPOINTMENT_SECURITY_ROLE'));
                        }

                        continueExecution(false);
                    });
                });
            });

            let continueExecution = (deleteAnyPermission: boolean) => {
                if (globals.divAppointmentDetails != undefined && globals.divAppointmentDetails != null) {
                    helper.cleanupPositionHelpers();
                    helper.hideSmartAssistant();
                }
                securityChecker.checkSecurityKey(meevoSecurityKeys.APPOINTMENTS_STANDINGDEFINITION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE).then(securityResult => {
                    if (
                        appointmentService.id != undefined &&
                        appointmentService.appointmentServiceScheduleId != undefined &&
                        securityResult !== Meevo.Model.SecurityAccessEnum.Hide
                    ) {
                        modal.showMessage('', {
                            buttonsType: Meevo.Model.ButtonTypeEnum.OkCancel,
                            customTemplateId: 'DeleteStandingPrompt',
                            callback: (result) => {
                                if (result === Meevo.Model.MessageBoxButtonResult.Ok) {
                                    if (service.editAppointmentChoice === 1) {
                                        service.deleteAppointment({
                                            appointmentId: appointmentService.appointmentId,
                                            id: appointmentService.id,
                                            clientId: appointmentService.clientId,
                                            startDate: appointmentService.startDate,
                                        });
                                    } else {
                                        if (securityResult === Meevo.Model.SecurityAccessEnum.Grant) {
                                            service.deleteAppointment({
                                                appointmentServiceScheduleId: appointmentService.appointmentServiceScheduleId,
                                                appointmentScheduleId: appointmentService.appointmentScheduleId,
                                                appointmentScheduleEntityVersion: appointmentService.appointmentScheduleEntityVersion,
                                            });
                                        } else {
                                            modal.showMessage($translate.instant('MESSAGE_NOT_IN_SECURITY_ROLE'));
                                        }
                                    }
                                }
                                service.editAppointmentChoice = 1;
                            },
                        });
                    } else if (appointmentService.id != undefined) {
                        _saveUponDelete = true;

                        service.appointmentServiceIdsToDelete = [];
                        if (deleteAnyPermission || user.userId === appointmentService.employeeId) {
                            service.appointmentServiceIdsToDelete.push(appointmentService.id);
                        }

                        service.deleteAppointReason = null;
                        globals.deletedIds = [];
                        globals.apptServicesBeingCancelledWithFee = [];

                        restServer.getAppointment(appointmentService.appointmentId).then((result) => {
                            if (!deleteAnyPermission) {
                                result.data.services = result.data.services.filter(
                                    appointmentService => user.userId === appointmentService.employeeId
                                );
                            }

                            result.data.services.forEach(appointmentService => {
                                appointmentService.client = {
                                    id: appointmentService.clientId,
                                    firstName: appointmentService.clientFirstName,
                                    lastName: appointmentService.clientLastName,
                                };
                                appointmentService.startTime = appointmentService.startDateTime;
                                appointmentService.startDate = moment(appointmentService.startDateTime).startOf('day').toDate();
                            });

                            service.appointHeaderDelete = result.data;

                            modal.showDeleteDialog(service.appointmentServiceIdsToDelete);
                        });
                    } else {
                        const url = `/api/appointmentSchedule/${appointmentService.appointmentScheduleId}/existsToday`;
                        dataService.customMethodData(url, 'GET', null).then((result: any) => {
                            let appointmentExistsToday = result.data;
                            if (appointmentExistsToday) {
                                modalService.confirmHandler('MESSAGE_STANDING_DEFINITION_APPOINTMENT_DELETE_TODAY').then((response: boolean) => {
                                    if (response) {
                                        dataService.objectStatePatch(
                                            'AppointmentSchedule',
                                            appointmentService.appointmentScheduleId,
                                            appointmentService.appointmentScheduleEntityVersion,
                                            Meevo.Model.ObjectStateEnum.Deleted,
                                            undefined,
                                            'deleteToday'
                                        )
                                        .then(() => {
                                            filterActions.filterBook();
                                        });
                                    } else {
                                        restServer.deleteAppointStandingAppointment(
                                            appointmentService.appointmentScheduleId,
                                            appointmentService.appointmentScheduleEntityVersion,
                                            filterActions.filterBook()
                                        );
                                    }
                                });
                            } else {
                                restServer.deleteAppointStandingAppointment(
                                    appointmentService.appointmentScheduleId,
                                    appointmentService.appointmentScheduleEntityVersion,
                                    filterActions.filterBook()
                                );
                            }
                        });
                    }
                });
            };
        },
        deletePendingAppointment: function(appointmentService) {
            let user = identityService.current();

            let meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
            securityChecker
                .checkSecurityKey(meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DELETEAPPOINTMENT)
                .then(result => {
                    if (result !== Meevo.Model.SecurityAccessEnum.Grant) {
                        return modal.showMessage($translate.instant('MESSAGE_NOT_IN_SECURITY_ROLE'));
                    }

                    securityChecker
                        .checkSecurityKey(
                            meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DELETEANYAPPOINTMENT
                        )
                        .then(result => {
                            if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                                continueExecution(true);
                                return;
                            }

                            restServer.getAppointment(appointmentService.appointmentId).then(result => {
                                let currentAppointment = result.data;

                                let isDeleteAllowed = _.some(
                                    currentAppointment.services,
                                    (appointmentService: any) => {
                                        return user.userId === appointmentService.employeeId;
                                    }
                                );

                                if (!isDeleteAllowed) {
                                    return modal.showMessage(
                                        $translate.instant('MESSAGE_NOT_IN_DELETE_ANY_APPOINTMENT_SECURITY_ROLE')
                                    );
                                }

                                continueExecution(false);
                            });
                        });
                });

            let continueExecution = (deleteAnyPermission: boolean) => {
                helper.cleanupPositionHelpers();
                helper.hideSmartAssistant();

                _saveUponDelete = true;

                service.appointmentServiceIdsToDelete = [];
                if (deleteAnyPermission || user.userId === appointmentService.employeeId) {
                    service.appointmentServiceIdsToDelete.push(appointmentService.id);
                }

                service.pendingAppointmentService = appointmentService;
                isFromWaitList = appointmentService.isFromWaitList;

                if (!isFromWaitList)
                    modal.showMessage($translate.instant('MESSAGE_DELETE_CONFIRMATION_PENDING'), {
                        buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                        callback: deletePendingAppointDetailsConfirmation,
                    });
                else deletePendingAppointDetailsConfirmation(Meevo.Model.MessageBoxButtonResult.Yes);
            };
        },
        bookPendingAppointment: function(pendingAppointmentService) {
            if (pendingAppointmentService.appointmentId != undefined) {
                let trackItem: Meevo.Model.TrackingItem = new Meevo.Model.TrackingItem(
                    Meevo.Model.NounEnum.AppointmentHeader,
                    Meevo.Model.VerbEnum.Accepted,
                    null,
                    pendingAppointmentService.appointmentId
                );
                trackingService.saveTrackingInfo(trackItem).catch(reason => {
                    /* do nothing */
                });

                restServer.getAppointment(pendingAppointmentService.appointmentId).then(function(result) {
                    let employeeBooked = false;
                    let resourceBooked = false;
                    isFromWaitList = pendingAppointmentService.isFromWaitList;
                    if (isFromWaitList) {
                        service.pendingAppointmentService = pendingAppointmentService;
                    }
                    globals.pendingIds = [];
                    result.data.services.forEach(function(appointmentServiceBeingBooked) {
                        if (
                            appointmentServiceBeingBooked.appointmentRequestId === pendingAppointmentService.appointmentRequestId &&
                                appointmentServiceBeingBooked.transitionState === Meevo.Model.AppointStateEnum.Pending
                        ) {
                            employeeBooked = appointmentServiceBeingBooked.employee ? true : employeeBooked;
                            resourceBooked = appointmentServiceBeingBooked.resource ? true : resourceBooked;
                            appointmentServiceBeingBooked.transitionState = Meevo.Model.AppointStateEnum.Booked;
                            globals.pendingIds.push(appointmentServiceBeingBooked.id);
                        }
                    });
                    service.savePendingAppointmentHeader(result.data, employeeBooked, resourceBooked);
                });

                helper.cleanupPositionHelpers();
                helper.hideSmartAssistant();
            }
        },
        savePendingAppointmentHeader(appointmentHeader, employeeBooked, resourceBooked) {
            restServer.saveAppointHeader(
                appointmentHeader,
                pendingAppointmentBookedSuccess,
                warnings =>
                    modal.showMessages(warnings, 'HEADER_APPOINTMENT_WARNING', {
                        buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                        callback: result => {
                            if (result === Meevo.Model.MessageBoxButtonResult.Yes) {
                                appointmentHeader.suppressWarnings = true;
                                service.savePendingAppointmentHeader(
                                    appointmentHeader,
                                    employeeBooked,
                                    resourceBooked
                                );
                            }
                        },
                    }),
                employeeBooked,
                resourceBooked
            );
        },
        openAppointment: function(details: any, displayMessage: boolean = true) {
            if (globals.divAppointmentDetails != undefined && globals.divAppointmentDetails != null) {
                helper.cleanupPositionHelpers();
                helper.hideSmartAssistant();
                helper.destroyResizable();
            }

            if (details.id != undefined) {
                $mdComponentRegistry.when('right').then(function(sideNav) {
                    if (helper.isEditorOpen(displayMessage)) {
                        return;
                    }

                    if (details.appointmentServiceScheduleId != undefined) {
                        modal.showMessage('', {
                            buttonsType: Meevo.Model.ButtonTypeEnum.OkCancel,
                            customTemplateId: service.isCheckedOut()
                                ? 'ViewStandingPrompt'
                                : 'EditStandingPrompt',
                            callback: function(result) {
                                if (result == Meevo.Model.MessageBoxButtonResult.Ok) {
                                    if (
                                        (service.isCheckedOut() && service.viewAppointmentChoice == 1) ||
                                        (!service.isCheckedOut() && service.editAppointmentChoice == 1)
                                    ) {
                                        service.openAppointment({
                                            id: details.id,
                                            appointmentId: details.appointmentId,
                                        });
                                    } else {
                                        getAppointmentScheduleId(details).then(appointmentScheduleId =>
                                        {
                                            service.openAppointment({
                                                appointmentScheduleId: appointmentScheduleId,
                                            });
                                        });
                                    }
                                }
                                service.editAppointmentChoice = 1;
                            },
                        });
                    } else {
                        $('body').focus(); // For Internet Explorer.
                        globals.deletedIds = [];
                        globals.apptServicesBeingCancelledWithFee = [];
                        $('#appointmentEditorForm #editor_maximized').hide();
                        $rootScope.$broadcast('openAppointment', {
                            appointmentServiceId: details.id,
                            id: details.appointmentId,
                            isReadOnly: service.isCheckedOut(details.finalState) || details.isInPast,
                            returnStateInfo: details.returnStateInfo
                        });
                        $mdSidenav('right').open();
                        $timeout(() => {
                            service.CheckForAdjustEditor();
                        });
                }
                });
            } else {
                service.goToState(
                    'standingAppointments',
                    Meevo.Model.MaintenanceFormState.Editing,
                    details.appointmentScheduleId
                );
            }
        },
        deleteAppointmentFromHeader: function(
            appointment,
            originalAppointment,
            appointmentServiceIdsToDelete,
            saveUponDelete
        ) {
            _saveUponDelete = saveUponDelete;
            service.appointmentServiceIdsToDelete = appointmentServiceIdsToDelete;
            service.deleteAppointReason = null;
            service.originalAppointment = originalAppointment;
            service.appointHeaderDelete = appointment;

            return modal.showDeleteDialog(appointmentServiceIdsToDelete);
        },
        deleteAppointmentFinal: function () {
            const selectedDeletedServiceCount = service.appointHeaderDelete.services.filter((service, i) => { return service.isApptToDeleteSelected; }).length
            if (selectedDeletedServiceCount == 0) {
                $('#divDialogDelete').hide()

                return modal.showMessage($translate.instant('MESSAGE_SELECTED_APPOINTMENT_REQUIRED_DELETE')).then(() => {
                    $('#divDialogDelete').show()
                })
            }

            if (
                globals.businessInfo.requireCancellationReasonWhenDeletingAnAppointment &&
                !isObject(service.deleteAppointReason)
            ) {
                $('#divDialogDelete').hide()
                return modal.showMessage($translate.instant('ERROR_DELETE_REASON_REQUIRED')).then(() => {
                    $('#divDialogDelete').show()
                })
            }

            deleteAppointDetailsConfirmation();
        },
        doubleBook() {
            service.details = undefined;
            service.block = undefined;
            helper.cleanupPositionHelpers();
            helper.hideSmartAssistant();
            globals.divCellHighlight.show();

            globals.fromDoubleBook = true;

            var oldevent = globals.divCellHighlight.data('clickedEvent');
            helper.showNewBooking(oldevent, setHighlightedCellTime);

            clearSelection();
        },

        sendToNotes(clientId: string, clientDisplayName: string, visitNotes: boolean) {
            if (clientId === null) {
                return;
            }

            $rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: 'client',
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    callbackState: 'appointmentBook',
                    id: clientId,
                    initialEditSection: visitNotes ? 'SECTION_CLIENT_VISIT_NOTES' : 'SECTION_CLIENT_NOTES',
                    clientDisplayName: $translate.instant(clientDisplayName),
                },
            });
        },

        sendToProfile(clientId: string, clientDisplayName: string) {
            if (clientId === null) {
                return;
            }

            $rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: 'client',
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    callbackState: 'appointmentBook',
                    id: clientId,
                    initialEditSection: 'SECTION_CLIENT_MAIN',
                    clientDisplayName: $translate.instant(clientDisplayName),
                },
            });
        },
        sendToHistory(clientId: string, clientDisplayName: string) {
            if (clientId === null) {
                return;
            }

            $rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: 'client',
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    callbackState: 'appointmentBook',
                    id: clientId,
                    initialEditSection: 'SECTION_HISTORY',
                    clientDisplayName: $translate.instant(clientDisplayName),
                },
            });
        },
        sendToClientCharts(clientDisplayName: string) {
            const details = this.details;
            const addOnIds = _.pluck(details.serviceAddOns || [], "addOnServiceId");
            const params = {
                id: details.clientId,
                appointmentServiceId: details.id,
                serviceId: details.serviceId,
                addOnServiceIds: addOnIds,
                sourceModule: Meevo.Model.ModuleEnum.AppointmentBook,
                period: moment(details.startDateTime).format("YYYYMMDD"),   
            };

            $rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: "client",
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    callbackState: "appointmentBook",
                    initialEditSection: "SECTION_CLIENT_CHARTS",
                    clientDisplayName: $translate.instant(clientDisplayName),
                    ...params,
                },
            });
        },
        sendToClientFind(clientId: string, landingTab: Meevo.Model.NounEnum = null) {
            if (clientId === null) {
                return;
            }

            sideContextMenu('Search').open().then((o) => {
                shortCutsService.activateGroup(this.searchMenuShortCutsGroup);
                $rootScope.$broadcast(Meevo.Components.Common.Messages.OPEN_SEARCH_MENU_COMPLETE, { id: clientId, landingTab: landingTab });
                trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.ClientFindSearch, Meevo.Model.VerbEnum.ClientFindButtonClicked, null));
            });
        },
        sendToExternalUrl(url: string) {
            if (url) {
                window.open(url, '_blank');
            }
        },
        toggleLinks(clientType: Number, bToggle: boolean) {
            if (this.clientIsAnon(clientType)) {
                return bToggle;
            } else {
                return !bToggle;
            }
        },
        canEditCheckedOutService(selectedAppointmentService) {
            if (!selectedAppointmentService) {
                return false;
            }
            if (!service.isCheckedOut(selectedAppointmentService.finalState)) {
                return false;
            }
            const startDateTime = moment(selectedAppointmentService.startDateTime).startOf('day');
            const cutoffDays = globals.businessInfo.maxDaysToAllowServiceStepEdit;
            const cutoffDate = startDateTime.add(cutoffDays, 'days');
            return !helper.isInPast(cutoffDate);
        },
        updateBlockDurationWithWarnings(block) {
            const updateBlock = (suppressWarnings: boolean) => {
                modal.showProcessingOverlay();

                block.suppressWarnings = true;

                restServer.saveAppointBlock(
                    block,
                    onSuccess,
                    suppressWarnings ? null : onWarn
                );
            };

            const onSuccess = (newBlock, action) => {
                modal.hideProcessingOverlay();

                if (action) {
                    action(newBlock);
                }

                $timeout(() => {
                    const columnBooking = updateColumnBooking(newBlock);
                    refreshAffectedColumn(newBlock, columnBooking.columnId, true);
                    helper.expandBook(moment(newBlock.startDateTime), moment(newBlock.endDateTime));
                });
            };

            const onWarn = (warnings) => {
                const warningCallback = (result) => {
                    if (result == Meevo.Model.MessageBoxButtonResult.Yes) {
                        updateBlock(true);
                    }
                }

                modal.hideProcessingOverlay();
                modal.showMessages(warnings, "HEADER_BLOCK_WARNING", { buttonsType: Meevo.Model.ButtonTypeEnum.YesNo, callback: warningCallback });
            }

            updateBlock(false);
        },
        updateAppointmentServiceStepsWithWarnings(appointment, appointmentService, isCheckedOutUpdate: boolean = true) {
            let defer = $q.defer();

            const preProcessCustomState = (customState) => {
                customState.clientDisplayName = $translate.instant(customState.clientDisplayName);
                return customState;
            };

            const updateCheckedOutService = (suppressWarnings: boolean) => {
                return restServer.updateCheckedOutService(
                    appointmentService.id,
                    appointmentService.steps,
                    appointmentService.employeeType, /* isRequested */
                    appointmentService.bookingType, /* isWalkin */
                    appointmentService.reBookingType, /* isRedo */
                    appointment.id,
                    appointment.entityVersion,
                    suppressWarnings,
                    isCheckedOutUpdate,
                    onSuccess,
                    suppressWarnings ? null : onWarning,
                    preProcessCustomState
                );
            }

            const onSuccess = (newAppointmentService, extraData) => {
                modal.hideProcessingOverlay();

                $timeout(() => {
                    if (extraData &&
                        extraData.request &&
                        extraData.request.MakeAppointmentServicesContiguous) {
                        filterActions.filterBook(false, true);
                    } else {
                        const columnBooking = updateColumnBooking(newAppointmentService);
                        refreshAffectedColumn(newAppointmentService, columnBooking.columnId, true);
                    }
                    helper.expandBook(moment(newAppointmentService.startDateTime), moment(newAppointmentService.startDateTime).add(newAppointmentService.totalMinutes, 'm'));
                    defer.resolve();
                });
            };

            const onWarning = (warnings) => {
                var warningCallback = (result: Meevo.Model.MessageBoxButtonResult) => {
                    if (result == Meevo.Model.MessageBoxButtonResult.Yes) {
                        updateCheckedOutService(true);
                    }
                }

                modal.hideProcessingOverlay();
                modal.showMessages(warnings, 'HEADER_APPOINTMENT_WARNING', {
                    buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                    callback: warningCallback
                });
            }

            updateCheckedOutService(false);

            return defer.promise;
        },
        showEditCheckedOutService: function(selectedAppointmentService, includeFinalizedServices: boolean = false) {
            if (!service.canEditCheckedOutService(selectedAppointmentService)) {
                return null;
            }
            return restServer.getAppointment(selectedAppointmentService.appointmentId, false, includeFinalizedServices).then(response => {
                const appointment = response.data;
                const appointmentService = _(response.data.services).find(service => service.id == selectedAppointmentService.id);

                return modal.showEditCheckedOutService(appointmentService, appointment).then((response) => {
                    if (response === 'close') {
                        return;
                    }

                    return service.updateAppointmentServiceStepsWithWarnings(appointment, appointmentService);
                });
            });
        },
        clientIsAnon(clientType: Number) {
            if (
                clientType == Meevo.Model.ClientTypeEnum.AnonymousFemale ||
                clientType == Meevo.Model.ClientTypeEnum.AnonymousMale ||
                clientType == Meevo.Model.ClientTypeEnum.AnonymousOther
            ) {
                return true;
            } else {
                return false;
            }
        },

        closeEditor: function() {
            var isOpen = $mdSidenav('right').isOpen();
            if (isOpen) {
                $mdSidenav('right').close();
                service.CheckForAdjustEditor();
            }
        },
        addStanding() {
            $rootScope.$broadcast('gotoState', { stateName: 'standingAppointments', stateParams: {} });
        },
        addBlockDefinition() {
            $rootScope.$broadcast('gotoState', { stateName: 'standingBlocks', stateParams: {} });
        },
        addDefinitionCallback() {
            filterActions.filterBook();
        },
        addMissedOpportunity() {
            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/AppointmentBook/views/MissedOpportunity.html',
                controller: 'meevo.plugins.appointmentbook.MissedOpportunityController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    actionService: service,
                    startingModel: null,
                },
                onRemoving: removeCallback,
            };
            $('#divAppointmentBookScrollContainer').css('overflow', 'hidden');
            modalService.showCustom(modalOptions).then(result => {
                $('#divAppointmentBookScrollContainer').css('overflow', '');
            });
        },
        addMissedOpportunityPreAddEditClient() {
            modalService.hide();
        },
        addMissedOpportunityAddEditClientCallback(model, callbackData) {
            if (Meevo.Model.Guard.isSomething(model)) {
                if (callbackData == null) {
                    callbackData = {
                        startDate: moment().toDate(),
                    };
                }
                callbackData.client = model;
                callbackData.clientId = model.id;
                callbackData.clientType = Meevo.Model.ClientTypeEnum.Client;
            }
            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/AppointmentBook/views/MissedOpportunity.html',
                controller: 'meevo.plugins.appointmentbook.MissedOpportunityController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    actionService: service,
                    startingModel: callbackData,
                },
            };
            modalService.showCustom(modalOptions);
        },
        isAccepted() {
            return (
                service.details &&
                service.details.dateBooked
            );
        },
        isBooked() {
            return (
                service.details &&
                service.details.transitionState &&
                service.details.transitionState === Meevo.Model.AppointStateEnum.Booked
            );
        },
        isRunningLate() {
            return (
                service.details &&
                service.details.transitionState &&
                service.details.transitionState === Meevo.Model.AppointStateEnum.RunningLate
            );
        },
        isNoShow() {
            return (
                service.details &&
                service.details.transitionState &&
                service.details.transitionState === Meevo.Model.AppointStateEnum.NoShow
            );
        },
        isCheckedOut(finalState = undefined) {
            return (
                finalState ?
                finalState === Meevo.Model.AppointFinalStateEnum.CheckedOut :
                service.details &&
                service.details.finalState &&
                service.details.finalState === Meevo.Model.AppointFinalStateEnum.CheckedOut
            );
        },
        isCheckedIn() {
            return (
                service.details &&
                service.details.transitionState &&
                service.details.transitionState === Meevo.Model.AppointStateEnum.CheckedIn &&
                service.details.finalState &&
                service.details.finalState === Meevo.Model.AppointFinalStateEnum.None
            );
        },
        isPending() {
            return (
                service.details &&
                service.details.transitionState &&
                service.details.transitionState === Meevo.Model.AppointStateEnum.Pending &&
                service.details.finalState &&
                service.details.finalState === Meevo.Model.AppointFinalStateEnum.None
            );
        },
        isWalkInPending() {
            return (
                service.details &&
                service.details.transitionState &&
                service.details.transitionState === Meevo.Model.AppointStateEnum.WalkInPending &&
                service.details.finalState &&
                service.details.finalState === Meevo.Model.AppointFinalStateEnum.None
            );
        },
        isConfirmationStatusVisible() {
            return service.details && !service.details.isInPast && !service.isCheckedOut() && service.isLocal(service.details.locationId) &&
                !service.isPending();
        },
        hasNoShowFee() {
            return globals.appointmentNoShowFeePercentage > 0;
        },
        goToState(stateName: string, actionState: Meevo.Model.MaintenanceFormState, id: any = undefined) {
            $rootScope.$broadcast('gotoState', {
                stateName: stateName,
                stateParams: {
                    callback: service.addDefinitionCallback,
                    callbackState: $state.current.name,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: actionState,
                    id: id,
                },
            });
        },
        isLocal(locationId) {
            return locationId == identityService.effectiveLocationId;
        },
        gotoConfirmationManager() {
            $rootScope.$broadcast('gotoState', { stateName: 'confirmationManager', stateParams: {} });
        },
        gotoWaitList() {
            $rootScope.$broadcast('gotoState', { stateName: 'waitList', stateParams: {} });
        },
        gotoClientIntake() {
            $rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: appSettings.ROUTE_NAMES.clientIntake,
                stateParams: {},
            });
        },
        gotoTimesPricing() {
            $rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: appSettings.ROUTE_NAMES.employeeServiceTimesPricing,
                stateParams: {},
            });
        },
        gotoCallCenter() {
            if (device.mobile()) {
                modalService.alert("LABEL_NOT_AVAILABLE_ON_MOBILE");
            } else {
                $rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: appSettings.ROUTE_NAMES.callCenter,
                    stateParams: {}
                });
            }
        },

        hasCustomControls() {
            var retVal = false;
            if (
                service.details &&
                ((service.details.hasBookingCustomControls &&
                    (service.details.transitionState == Meevo.Model.AppointStateEnum.Booked ||
                        service.isPending() ||
                        service.isWalkInPending())) ||
                    (service.details.hasCheckinCustomControls &&
                        (service.isCheckedIn() || service.isCheckedOut())) ||
                    (service.details.hasCheckoutCustomControls && service.isCheckedOut()) ||
                    service.details.address1)
            ) {
                retVal = true;
            }

            return retVal;
        },
        displayServiceCustomAnswers() {
            showServiceCustomAnswers();
        },
        displayClientNote(client, isCheckingOut: boolean, showClientNote: boolean, appointmentNoteObj?: any) {
            //console.log('AppointmentBookActionsServices:displayClientNote (from client find)', arguments);
            const noteClient: Meevo.Plugins.Note.INoteClient = {
                entityId: client.clientId,
                clientId: client.clientId,
                clientType: client.clientType,
                clientDisplayName: client.displayName
            };
            return displayCombinedNote(appointmentNoteObj, noteClient, undefined, undefined, isCheckingOut, showClientNote, client.noteType);
        },
        displayAggregatedNotes(aggregatedNotes: Meevo.Plugins.Note.INote[], noteViewTime: Meevo.Model.ClientNoteViewTimeEnum, isCheckingOut: boolean, showClientNote: boolean, appointmentNoteObj?: any) {
            //console.log('AppointmentBookActionsServices:displayAggregatedNotes', arguments);
            return displayCombinedNote(appointmentNoteObj, undefined, undefined, aggregatedNotes, isCheckingOut, showClientNote, noteViewTime);
        },
        getAnyNotCheckedInServicesForCheckOut(appointmentServices: any, checkingOut: boolean) {
            //Service in TransitionState = "Checked In" that is being Checked Out to register should not display "Checked In" Note again. [For multi-Client Appointments, CheckIn/Out is processed for only one Client in AB]
            //In multi-Service Check Out, see if any Service was was not checked In, so Client Note needs to be displayed(though it was already displayed at least once for another Service(s) that were Checked-In)
            if (appointmentServices.length === 1) {
                return !(appointmentServices[0].transitionState === Meevo.Model.AppointStateEnum.CheckedIn && checkingOut);
            } else {
                let anyServicesNotCheckedIn = _(appointmentServices).reject((service) => { return service.transitionState === Meevo.Model.AppointStateEnum.CheckedIn });
                return (anyServicesNotCheckedIn && anyServicesNotCheckedIn.length > 0);
            }
        },
        showTransactionLink(serviceDetails) {
            let retVal = serviceDetails && serviceDetails.transactionId
                && (serviceDetails.isCheckedOut
                    || (serviceDetails.transitionState === Meevo.Model.AppointStateEnum.NoShow && serviceDetails.finalState === Meevo.Model.AppointFinalStateEnum.None)
                    );
            return retVal;
        },
        openTransactionEditorTransactionHistory(transactionId: string): void {
            if (!transactionId) return;

            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: Number(transactionId),
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };
            $rootScope.$broadcast("gotoState", {
                stateName: appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams,
                securityKey: Meevo.Components.Common.SecurityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            });
        },
        showTextIcon(): boolean {
            return service.details && service.details.notificationClientHasMobilePhone &&
                (globals.textelPermission || globals.isSmsEnabledCurrentLevel);
        },
        sendText(): void {

            if (!globals.textelPermission && !globals.twoWaySmsPermission) {
                service.sendToClientFind(service.details.notificationClientId, Meevo.Model.NounEnum.ClientFindSendTextMsgTab);
                return;
            }

            $rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: appSettings.ROUTE_NAMES.meevoMessenger,
                stateParams: {
                    id: service.details.notificationClientId,
                    firstName: service.details.payingClientFirstName,
                    lastName: service.details.payingClientLastName,
                    primaryPhoneNumber: service.details.notificationClientPhoneNumber,
                    countryCode: service.details.notificationClientCountryCode,
                    isRestricted: false,
                    isClient: true,
                    classification: globals.textelPermission ? 'TEXTEL' : 'SMS',
                }
            });


        },
        sendTextSecurityKey(): string {
            if (globals.twoWaySmsPermission) {
                return Meevo.Components.Common.SecurityKeys.INTEGRATION_TWOWAYSMS
            }

            return globals.textelPermission ?
                Meevo.Components.Common.SecurityKeys.INTEGRATION_TEXTEL :
                Meevo.Components.Common.SecurityKeys.DATA_CLIENTFIND_SENDTEXTMSG
        },
        isAnonymousClient(clientType: Meevo.Model.ClientTypeEnum) {
            return clientType === Meevo.Model.ClientTypeEnum.AnonymousFemale ||
                clientType === Meevo.Model.ClientTypeEnum.AnonymousMale ||
                clientType === Meevo.Model.ClientTypeEnum.AnonymousOther;
        },
        isProductUsageVisible(): boolean {
            if (!service.details) {
                return false;
            }

            // this is set in onAppointmentBookDetailPopupSuccess
            if (!service.details.isAnyServiceEnabledForProductUsage) {
                return false;
            }

            if (service.isCheckedOut()) {
                return false;
            }

            return true;
        },
        productUsage() {
            productUsageModalBridge.open(
                service.details.id,
                $translate.instant(service.details.clientDisplayName),
            );
        },
        // Converts a Date object or ISO string to 'yyyymmdd' format as a number
        toYYYYMMDD(date: Date | string): number {
            const d = typeof date === "string" ? new Date(date) : date;
            const year = d.getFullYear();
            const month = ("0" + (d.getMonth() + 1)).slice(-2);
            const day = ("0" + d.getDate()).slice(-2);
            return parseInt(`${year}${month}${day}`, 10);
        }
    };
    return service;
}]);
